import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, ChangeDetectionStrategy, Input, Output, ViewChild, HostBinding, Directive, forwardRef, Host, HostListener, NgModule } from '@angular/core';
import { filter, map, take, takeUntil, distinctUntilChanged } from 'rxjs/operators';
import { isFirstDayOfWeek, getDay, shiftDate, isBefore, endOf, isAfter, startOf, isArray, isSame, getFirstDayOfMonth, formatDate, getLocale, isSameMonth, isSameDay, isDisabledDay, isSameYear, isDateValid, setFullDate, getMonth, getFullYear, isDate, parseDate, utcAsLocal } from 'ngx-bootstrap/chronos';
import * as i5 from 'ngx-bootstrap/positioning';
import { PositioningService } from 'ngx-bootstrap/positioning';
import * as i6 from 'ngx-bootstrap/timepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Subscription, BehaviorSubject, combineLatest, Subject } from 'rxjs';
import { MiniStore, MiniState } from 'ngx-bootstrap/mini-ngrx';
import { NgFor, NgIf, NgClass, NgSwitch, NgSwitchCase, AsyncPipe, CommonModule } from '@angular/common';
import * as i2 from 'ngx-bootstrap/tooltip';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import * as i2$1 from 'ngx-bootstrap/component-loader';
import { ComponentLoaderFactory } from 'ngx-bootstrap/component-loader';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';

/**
 * For date range picker there are `BsDaterangepickerConfig` which inherits all properties,
 * except `displayMonths`, for range picker it default to `2`
 */
function BsCustomDatesViewComponent_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function BsCustomDatesViewComponent_button_1_Template_button_click_0_listener() {
      const range_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.selectFromRanges(range_r2));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const range_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("selected", ctx_r2.compareRanges(range_r2));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", range_r2.label, " ");
  }
}
function BsDatepickerNavigationViewComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " \u200B ");
    i0.ɵɵelementStart(2, "button", 2);
    i0.ɵɵlistener("click", function BsDatepickerNavigationViewComponent_ng_container_3_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.view("month"));
    });
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.isDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.calendar.monthTitle);
  }
}
const _c0 = [[["bs-datepicker-navigation-view"]], "*"];
const _c1 = ["bs-datepicker-navigation-view", "*"];
function BsCalendarLayoutComponent_bs_current_date_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "bs-current-date", 4);
  }
}
function BsCalendarLayoutComponent_bs_timepicker_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "bs-timepicker");
  }
}
function BsYearsCalendarViewComponent_tr_4_td_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 4);
    i0.ɵɵlistener("click", function BsYearsCalendarViewComponent_tr_4_td_1_Template_td_click_0_listener() {
      const year_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.viewYear(year_r2));
    })("mouseenter", function BsYearsCalendarViewComponent_tr_4_td_1_Template_td_mouseenter_0_listener() {
      const year_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.hoverYear(year_r2, true));
    })("mouseleave", function BsYearsCalendarViewComponent_tr_4_td_1_Template_td_mouseleave_0_listener() {
      const year_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.hoverYear(year_r2, false));
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const year_r2 = ctx.$implicit;
    i0.ɵɵclassProp("disabled", year_r2.isDisabled)("is-highlighted", year_r2.isHovered);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("selected", year_r2.isSelected);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(year_r2.label);
  }
}
function BsYearsCalendarViewComponent_tr_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, BsYearsCalendarViewComponent_tr_4_td_1_Template, 3, 7, "td", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", row_r4);
  }
}
function BsMonthCalendarViewComponent_tr_4_td_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 4);
    i0.ɵɵlistener("click", function BsMonthCalendarViewComponent_tr_4_td_1_Template_td_click_0_listener() {
      const month_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.viewMonth(month_r2));
    })("mouseenter", function BsMonthCalendarViewComponent_tr_4_td_1_Template_td_mouseenter_0_listener() {
      const month_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.hoverMonth(month_r2, true));
    })("mouseleave", function BsMonthCalendarViewComponent_tr_4_td_1_Template_td_mouseleave_0_listener() {
      const month_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.hoverMonth(month_r2, false));
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const month_r2 = ctx.$implicit;
    i0.ɵɵclassProp("disabled", month_r2.isDisabled)("is-highlighted", month_r2.isHovered);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("selected", month_r2.isSelected);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(month_r2.label);
  }
}
function BsMonthCalendarViewComponent_tr_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, BsMonthCalendarViewComponent_tr_4_td_1_Template, 3, 7, "td", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", row_r4);
  }
}
const _c2 = ["bsDatepickerDayDecorator", ""];
function BsDaysCalendarViewComponent_th_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th");
  }
}
function BsDaysCalendarViewComponent_th_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r1 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.calendar.weekdays[i_r1], " ");
  }
}
function BsDaysCalendarViewComponent_tr_8_td_1_span_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵlistener("click", function BsDaysCalendarViewComponent_tr_8_td_1_span_1_Template_span_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const week_r4 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectWeek(week_r4));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r5 = i0.ɵɵnextContext(2).index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.calendar.weekNumbers[i_r5]);
  }
}
function BsDaysCalendarViewComponent_tr_8_td_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵlistener("click", function BsDaysCalendarViewComponent_tr_8_td_1_span_2_Template_span_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const week_r4 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectWeek(week_r4));
    })("mouseenter", function BsDaysCalendarViewComponent_tr_8_td_1_span_2_Template_span_mouseenter_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const week_r4 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.weekHoverHandler(week_r4, true));
    })("mouseleave", function BsDaysCalendarViewComponent_tr_8_td_1_span_2_Template_span_mouseleave_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const week_r4 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.weekHoverHandler(week_r4, false));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r5 = i0.ɵɵnextContext(2).index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.calendar.weekNumbers[i_r5]);
  }
}
function BsDaysCalendarViewComponent_tr_8_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 8);
    i0.ɵɵtemplate(1, BsDaysCalendarViewComponent_tr_8_td_1_span_1_Template, 2, 1, "span", 9)(2, BsDaysCalendarViewComponent_tr_8_td_1_span_2_Template, 2, 1, "span", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("active-week", ctx_r1.isWeekHovered);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isiOS);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isiOS);
  }
}
function BsDaysCalendarViewComponent_tr_8_td_2_span_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵlistener("click", function BsDaysCalendarViewComponent_tr_8_td_2_span_1_Template_span_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const day_r8 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.selectDay(day_r8));
    })("mouseenter", function BsDaysCalendarViewComponent_tr_8_td_2_span_1_Template_span_mouseenter_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const day_r8 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.hoverDay(day_r8, true));
    })("mouseleave", function BsDaysCalendarViewComponent_tr_8_td_2_span_1_Template_span_mouseleave_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const day_r8 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.hoverDay(day_r8, false));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("tooltip", day_r8.tooltipText);
    i0.ɵɵproperty("day", day_r8);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", day_r8.label, " 3");
  }
}
function BsDaysCalendarViewComponent_tr_8_td_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵlistener("click", function BsDaysCalendarViewComponent_tr_8_td_2_span_2_Template_span_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const day_r8 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.selectDay(day_r8));
    })("mouseenter", function BsDaysCalendarViewComponent_tr_8_td_2_span_2_Template_span_mouseenter_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const day_r8 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.hoverDay(day_r8, true));
    })("mouseleave", function BsDaysCalendarViewComponent_tr_8_td_2_span_2_Template_span_mouseleave_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const day_r8 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.hoverDay(day_r8, false));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("day", day_r8);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", day_r8.label, " 2");
  }
}
function BsDaysCalendarViewComponent_tr_8_td_2_span_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵlistener("click", function BsDaysCalendarViewComponent_tr_8_td_2_span_3_Template_span_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const day_r8 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.selectDay(day_r8));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("day", day_r8);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", day_r8.label, " 1");
  }
}
function BsDaysCalendarViewComponent_tr_8_td_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 13);
    i0.ɵɵtemplate(1, BsDaysCalendarViewComponent_tr_8_td_2_span_1_Template, 2, 3, "span", 14)(2, BsDaysCalendarViewComponent_tr_8_td_2_span_2_Template, 2, 2, "span", 15)(3, BsDaysCalendarViewComponent_tr_8_td_2_span_3_Template, 2, 2, "span", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isiOS && ctx_r1.isShowTooltip);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isiOS && !ctx_r1.isShowTooltip);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isiOS);
  }
}
function BsDaysCalendarViewComponent_tr_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, BsDaysCalendarViewComponent_tr_8_td_1_Template, 3, 4, "td", 6)(2, BsDaysCalendarViewComponent_tr_8_td_2_Template, 4, 3, "td", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const week_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.options && ctx_r1.options.showWeekNumbers);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", week_r4.days);
  }
}
const _c3 = ["startTP"];
function BsDatepickerContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "bs-days-calendar-view", 13);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("onNavigate", function BsDatepickerContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onNavigate_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.navigateTo($event));
    })("onViewMode", function BsDatepickerContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onViewMode_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setViewMode($event));
    })("onHover", function BsDatepickerContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onHover_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.dayHoverHandler($event));
    })("onHoverWeek", function BsDatepickerContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onHoverWeek_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.weekHoverHandler($event));
    })("onSelect", function BsDatepickerContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onSelect_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.daySelectHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const calendar_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("bs-datepicker-multiple", ctx_r1.multipleCalendars);
    i0.ɵɵproperty("calendar", calendar_r4)("isDisabled", ctx_r1.isDatePickerDisabled)("options", i0.ɵɵpipeBind1(1, 5, ctx_r1.options$));
  }
}
function BsDatepickerContainerComponent_div_0_ng_container_4_div_4_timepicker_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "timepicker", 15, 1);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", ctx_r1.isDatePickerDisabled);
  }
}
function BsDatepickerContainerComponent_div_0_ng_container_4_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "timepicker", 15, 0);
    i0.ɵɵtemplate(3, BsDatepickerContainerComponent_div_0_ng_container_4_div_4_timepicker_3_Template, 2, 1, "timepicker", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.isDatePickerDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isRangePicker);
  }
}
function BsDatepickerContainerComponent_div_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵtemplate(2, BsDatepickerContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template, 2, 7, "bs-days-calendar-view", 11);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, BsDatepickerContainerComponent_div_0_ng_container_4_div_4_Template, 4, 2, "div", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(3, 2, ctx_r1.daysCalendar$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.withTimepicker);
  }
}
function BsDatepickerContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "bs-month-calendar-view", 18);
    i0.ɵɵlistener("onNavigate", function BsDatepickerContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template_bs_month_calendar_view_onNavigate_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.navigateTo($event));
    })("onViewMode", function BsDatepickerContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template_bs_month_calendar_view_onViewMode_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setViewMode($event));
    })("onHover", function BsDatepickerContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template_bs_month_calendar_view_onHover_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.monthHoverHandler($event));
    })("onSelect", function BsDatepickerContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template_bs_month_calendar_view_onSelect_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.monthSelectHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const calendar_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("bs-datepicker-multiple", ctx_r1.multipleCalendars);
    i0.ɵɵproperty("calendar", calendar_r6);
  }
}
function BsDatepickerContainerComponent_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, BsDatepickerContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template, 1, 3, "bs-month-calendar-view", 17);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r1.monthsCalendar));
  }
}
function BsDatepickerContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "bs-years-calendar-view", 18);
    i0.ɵɵlistener("onNavigate", function BsDatepickerContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template_bs_years_calendar_view_onNavigate_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.navigateTo($event));
    })("onViewMode", function BsDatepickerContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template_bs_years_calendar_view_onViewMode_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setViewMode($event));
    })("onHover", function BsDatepickerContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template_bs_years_calendar_view_onHover_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.yearHoverHandler($event));
    })("onSelect", function BsDatepickerContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template_bs_years_calendar_view_onSelect_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.yearSelectHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const calendar_r8 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("bs-datepicker-multiple", ctx_r1.multipleCalendars);
    i0.ɵɵproperty("calendar", calendar_r8);
  }
}
function BsDatepickerContainerComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, BsDatepickerContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template, 1, 3, "bs-years-calendar-view", 17);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r1.yearsCalendar));
  }
}
function BsDatepickerContainerComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "button", 20);
    i0.ɵɵtext(2, "Apply");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 21);
    i0.ɵɵtext(4, "Cancel");
    i0.ɵɵelementEnd()();
  }
}
function BsDatepickerContainerComponent_div_0_div_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "button", 25);
    i0.ɵɵlistener("click", function BsDatepickerContainerComponent_div_0_div_8_div_1_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setToday());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("today-left", ctx_r1.todayPos === "left")("today-right", ctx_r1.todayPos === "right")("today-center", ctx_r1.todayPos === "center");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.todayBtnLbl);
  }
}
function BsDatepickerContainerComponent_div_0_div_8_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "button", 25);
    i0.ɵɵlistener("click", function BsDatepickerContainerComponent_div_0_div_8_div_2_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.clearDate());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("clear-left", ctx_r1.clearPos === "left")("clear-right", ctx_r1.clearPos === "right")("clear-center", ctx_r1.clearPos === "center");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.clearBtnLbl);
  }
}
function BsDatepickerContainerComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, BsDatepickerContainerComponent_div_0_div_8_div_1_Template, 3, 7, "div", 22)(2, BsDatepickerContainerComponent_div_0_div_8_div_2_Template, 3, 7, "div", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showTodayBtn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showClearBtn);
  }
}
function BsDatepickerContainerComponent_div_0_div_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "bs-custom-date-view", 28);
    i0.ɵɵlistener("onSelect", function BsDatepickerContainerComponent_div_0_div_9_Template_bs_custom_date_view_onSelect_1_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.setRangeOnCalendar($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("selectedRange", ctx_r1.chosenRange)("ranges", ctx_r1.customRanges)("customRangeLabel", ctx_r1.customRangeBtnLbl);
  }
}
function BsDatepickerContainerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵlistener("@datepickerAnimation.done", function BsDatepickerContainerComponent_div_0_Template_div_animation_datepickerAnimation_done_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.positionServiceEnable());
    });
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵtemplate(4, BsDatepickerContainerComponent_div_0_ng_container_4_Template, 5, 4, "ng-container", 6)(5, BsDatepickerContainerComponent_div_0_div_5_Template, 3, 3, "div", 7)(6, BsDatepickerContainerComponent_div_0_div_6_Template, 3, 3, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, BsDatepickerContainerComponent_div_0_div_7_Template, 5, 0, "div", 8)(8, BsDatepickerContainerComponent_div_0_div_8_Template, 3, 2, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, BsDatepickerContainerComponent_div_0_div_9_Template, 2, 3, "div", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.containerClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("@datepickerAnimation", ctx_r1.animationState);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", i0.ɵɵpipeBind1(3, 9, ctx_r1.viewMode));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitchCase", "day");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "month");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "year");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showTodayBtn || ctx_r1.showClearBtn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.customRanges && ctx_r1.customRanges.length > 0);
  }
}
function BsDatepickerInlineContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "bs-days-calendar-view", 13);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("onNavigate", function BsDatepickerInlineContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onNavigate_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.navigateTo($event));
    })("onViewMode", function BsDatepickerInlineContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onViewMode_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setViewMode($event));
    })("onHover", function BsDatepickerInlineContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onHover_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.dayHoverHandler($event));
    })("onHoverWeek", function BsDatepickerInlineContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onHoverWeek_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.weekHoverHandler($event));
    })("onSelect", function BsDatepickerInlineContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onSelect_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.daySelectHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const calendar_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("bs-datepicker-multiple", ctx_r1.multipleCalendars);
    i0.ɵɵproperty("calendar", calendar_r4)("isDisabled", ctx_r1.isDatePickerDisabled)("options", i0.ɵɵpipeBind1(1, 5, ctx_r1.options$));
  }
}
function BsDatepickerInlineContainerComponent_div_0_ng_container_4_div_4_timepicker_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "timepicker", 15, 1);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", ctx_r1.isDatePickerDisabled);
  }
}
function BsDatepickerInlineContainerComponent_div_0_ng_container_4_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "timepicker", 15, 0);
    i0.ɵɵtemplate(3, BsDatepickerInlineContainerComponent_div_0_ng_container_4_div_4_timepicker_3_Template, 2, 1, "timepicker", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.isDatePickerDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isRangePicker);
  }
}
function BsDatepickerInlineContainerComponent_div_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵtemplate(2, BsDatepickerInlineContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template, 2, 7, "bs-days-calendar-view", 11);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, BsDatepickerInlineContainerComponent_div_0_ng_container_4_div_4_Template, 4, 2, "div", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(3, 2, ctx_r1.daysCalendar$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.withTimepicker);
  }
}
function BsDatepickerInlineContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "bs-month-calendar-view", 18);
    i0.ɵɵlistener("onNavigate", function BsDatepickerInlineContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template_bs_month_calendar_view_onNavigate_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.navigateTo($event));
    })("onViewMode", function BsDatepickerInlineContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template_bs_month_calendar_view_onViewMode_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setViewMode($event));
    })("onHover", function BsDatepickerInlineContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template_bs_month_calendar_view_onHover_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.monthHoverHandler($event));
    })("onSelect", function BsDatepickerInlineContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template_bs_month_calendar_view_onSelect_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.monthSelectHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const calendar_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("bs-datepicker-multiple", ctx_r1.multipleCalendars);
    i0.ɵɵproperty("calendar", calendar_r6);
  }
}
function BsDatepickerInlineContainerComponent_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, BsDatepickerInlineContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template, 1, 3, "bs-month-calendar-view", 17);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r1.monthsCalendar));
  }
}
function BsDatepickerInlineContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "bs-years-calendar-view", 18);
    i0.ɵɵlistener("onNavigate", function BsDatepickerInlineContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template_bs_years_calendar_view_onNavigate_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.navigateTo($event));
    })("onViewMode", function BsDatepickerInlineContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template_bs_years_calendar_view_onViewMode_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setViewMode($event));
    })("onHover", function BsDatepickerInlineContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template_bs_years_calendar_view_onHover_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.yearHoverHandler($event));
    })("onSelect", function BsDatepickerInlineContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template_bs_years_calendar_view_onSelect_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.yearSelectHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const calendar_r8 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("bs-datepicker-multiple", ctx_r1.multipleCalendars);
    i0.ɵɵproperty("calendar", calendar_r8);
  }
}
function BsDatepickerInlineContainerComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, BsDatepickerInlineContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template, 1, 3, "bs-years-calendar-view", 17);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r1.yearsCalendar));
  }
}
function BsDatepickerInlineContainerComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "button", 20);
    i0.ɵɵtext(2, "Apply");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 21);
    i0.ɵɵtext(4, "Cancel");
    i0.ɵɵelementEnd()();
  }
}
function BsDatepickerInlineContainerComponent_div_0_div_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "button", 25);
    i0.ɵɵlistener("click", function BsDatepickerInlineContainerComponent_div_0_div_8_div_1_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setToday());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("today-left", ctx_r1.todayPos === "left")("today-right", ctx_r1.todayPos === "right")("today-center", ctx_r1.todayPos === "center");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.todayBtnLbl);
  }
}
function BsDatepickerInlineContainerComponent_div_0_div_8_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "button", 25);
    i0.ɵɵlistener("click", function BsDatepickerInlineContainerComponent_div_0_div_8_div_2_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.clearDate());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("clear-left", ctx_r1.clearPos === "left")("clear-right", ctx_r1.clearPos === "right")("clear-center", ctx_r1.clearPos === "center");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.clearBtnLbl);
  }
}
function BsDatepickerInlineContainerComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, BsDatepickerInlineContainerComponent_div_0_div_8_div_1_Template, 3, 7, "div", 22)(2, BsDatepickerInlineContainerComponent_div_0_div_8_div_2_Template, 3, 7, "div", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showTodayBtn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showClearBtn);
  }
}
function BsDatepickerInlineContainerComponent_div_0_div_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "bs-custom-date-view", 28);
    i0.ɵɵlistener("onSelect", function BsDatepickerInlineContainerComponent_div_0_div_9_Template_bs_custom_date_view_onSelect_1_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.setRangeOnCalendar($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("selectedRange", ctx_r1.chosenRange)("ranges", ctx_r1.customRanges)("customRangeLabel", ctx_r1.customRangeBtnLbl);
  }
}
function BsDatepickerInlineContainerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵlistener("@datepickerAnimation.done", function BsDatepickerInlineContainerComponent_div_0_Template_div_animation_datepickerAnimation_done_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.positionServiceEnable());
    });
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵtemplate(4, BsDatepickerInlineContainerComponent_div_0_ng_container_4_Template, 5, 4, "ng-container", 6)(5, BsDatepickerInlineContainerComponent_div_0_div_5_Template, 3, 3, "div", 7)(6, BsDatepickerInlineContainerComponent_div_0_div_6_Template, 3, 3, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, BsDatepickerInlineContainerComponent_div_0_div_7_Template, 5, 0, "div", 8)(8, BsDatepickerInlineContainerComponent_div_0_div_8_Template, 3, 2, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, BsDatepickerInlineContainerComponent_div_0_div_9_Template, 2, 3, "div", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.containerClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("@datepickerAnimation", ctx_r1.animationState);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", i0.ɵɵpipeBind1(3, 9, ctx_r1.viewMode));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitchCase", "day");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "month");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "year");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showTodayBtn || ctx_r1.showClearBtn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.customRanges && ctx_r1.customRanges.length > 0);
  }
}
const _c4 = ["endTP"];
function BsDaterangepickerContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "bs-days-calendar-view", 13);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("onNavigate", function BsDaterangepickerContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onNavigate_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.navigateTo($event));
    })("onViewMode", function BsDaterangepickerContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onViewMode_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setViewMode($event));
    })("onHover", function BsDaterangepickerContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onHover_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.dayHoverHandler($event));
    })("onHoverWeek", function BsDaterangepickerContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onHoverWeek_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.weekHoverHandler($event));
    })("onSelect", function BsDaterangepickerContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onSelect_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.daySelectHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const calendar_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("bs-datepicker-multiple", ctx_r1.multipleCalendars);
    i0.ɵɵproperty("calendar", calendar_r4)("isDisabled", ctx_r1.isDatePickerDisabled)("options", i0.ɵɵpipeBind1(1, 5, ctx_r1.options$));
  }
}
function BsDaterangepickerContainerComponent_div_0_ng_container_4_div_4_timepicker_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "timepicker", 15, 1);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", ctx_r1.isDatePickerDisabled);
  }
}
function BsDaterangepickerContainerComponent_div_0_ng_container_4_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "timepicker", 15, 0);
    i0.ɵɵtemplate(3, BsDaterangepickerContainerComponent_div_0_ng_container_4_div_4_timepicker_3_Template, 2, 1, "timepicker", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.isDatePickerDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isRangePicker);
  }
}
function BsDaterangepickerContainerComponent_div_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵtemplate(2, BsDaterangepickerContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template, 2, 7, "bs-days-calendar-view", 11);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, BsDaterangepickerContainerComponent_div_0_ng_container_4_div_4_Template, 4, 2, "div", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(3, 2, ctx_r1.daysCalendar$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.withTimepicker);
  }
}
function BsDaterangepickerContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "bs-month-calendar-view", 18);
    i0.ɵɵlistener("onNavigate", function BsDaterangepickerContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template_bs_month_calendar_view_onNavigate_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.navigateTo($event));
    })("onViewMode", function BsDaterangepickerContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template_bs_month_calendar_view_onViewMode_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setViewMode($event));
    })("onHover", function BsDaterangepickerContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template_bs_month_calendar_view_onHover_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.monthHoverHandler($event));
    })("onSelect", function BsDaterangepickerContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template_bs_month_calendar_view_onSelect_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.monthSelectHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const calendar_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("bs-datepicker-multiple", ctx_r1.multipleCalendars);
    i0.ɵɵproperty("calendar", calendar_r6);
  }
}
function BsDaterangepickerContainerComponent_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, BsDaterangepickerContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template, 1, 3, "bs-month-calendar-view", 17);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r1.monthsCalendar));
  }
}
function BsDaterangepickerContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "bs-years-calendar-view", 18);
    i0.ɵɵlistener("onNavigate", function BsDaterangepickerContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template_bs_years_calendar_view_onNavigate_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.navigateTo($event));
    })("onViewMode", function BsDaterangepickerContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template_bs_years_calendar_view_onViewMode_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setViewMode($event));
    })("onHover", function BsDaterangepickerContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template_bs_years_calendar_view_onHover_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.yearHoverHandler($event));
    })("onSelect", function BsDaterangepickerContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template_bs_years_calendar_view_onSelect_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.yearSelectHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const calendar_r8 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("bs-datepicker-multiple", ctx_r1.multipleCalendars);
    i0.ɵɵproperty("calendar", calendar_r8);
  }
}
function BsDaterangepickerContainerComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, BsDaterangepickerContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template, 1, 3, "bs-years-calendar-view", 17);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r1.yearsCalendar));
  }
}
function BsDaterangepickerContainerComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "button", 20);
    i0.ɵɵtext(2, "Apply");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 21);
    i0.ɵɵtext(4, "Cancel");
    i0.ɵɵelementEnd()();
  }
}
function BsDaterangepickerContainerComponent_div_0_div_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "button", 25);
    i0.ɵɵlistener("click", function BsDaterangepickerContainerComponent_div_0_div_8_div_1_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setToday());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("today-left", ctx_r1.todayPos === "left")("today-right", ctx_r1.todayPos === "right")("today-center", ctx_r1.todayPos === "center");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.todayBtnLbl);
  }
}
function BsDaterangepickerContainerComponent_div_0_div_8_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "button", 25);
    i0.ɵɵlistener("click", function BsDaterangepickerContainerComponent_div_0_div_8_div_2_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.clearDate());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("clear-left", ctx_r1.clearPos === "left")("clear-right", ctx_r1.clearPos === "right")("clear-center", ctx_r1.clearPos === "center");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.clearBtnLbl);
  }
}
function BsDaterangepickerContainerComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, BsDaterangepickerContainerComponent_div_0_div_8_div_1_Template, 3, 7, "div", 22)(2, BsDaterangepickerContainerComponent_div_0_div_8_div_2_Template, 3, 7, "div", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showTodayBtn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showClearBtn);
  }
}
function BsDaterangepickerContainerComponent_div_0_div_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "bs-custom-date-view", 28);
    i0.ɵɵlistener("onSelect", function BsDaterangepickerContainerComponent_div_0_div_9_Template_bs_custom_date_view_onSelect_1_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.setRangeOnCalendar($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("selectedRange", ctx_r1.chosenRange)("ranges", ctx_r1.customRanges)("customRangeLabel", ctx_r1.customRangeBtnLbl);
  }
}
function BsDaterangepickerContainerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵlistener("@datepickerAnimation.done", function BsDaterangepickerContainerComponent_div_0_Template_div_animation_datepickerAnimation_done_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.positionServiceEnable());
    });
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵtemplate(4, BsDaterangepickerContainerComponent_div_0_ng_container_4_Template, 5, 4, "ng-container", 6)(5, BsDaterangepickerContainerComponent_div_0_div_5_Template, 3, 3, "div", 7)(6, BsDaterangepickerContainerComponent_div_0_div_6_Template, 3, 3, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, BsDaterangepickerContainerComponent_div_0_div_7_Template, 5, 0, "div", 8)(8, BsDaterangepickerContainerComponent_div_0_div_8_Template, 3, 2, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, BsDaterangepickerContainerComponent_div_0_div_9_Template, 2, 3, "div", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.containerClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("@datepickerAnimation", ctx_r1.animationState);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", i0.ɵɵpipeBind1(3, 9, ctx_r1.viewMode));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitchCase", "day");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "month");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "year");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showTodayBtn || ctx_r1.showClearBtn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.customRanges && ctx_r1.customRanges.length > 0);
  }
}
function BsDaterangepickerInlineContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "bs-days-calendar-view", 13);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("onNavigate", function BsDaterangepickerInlineContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onNavigate_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.navigateTo($event));
    })("onViewMode", function BsDaterangepickerInlineContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onViewMode_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setViewMode($event));
    })("onHover", function BsDaterangepickerInlineContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onHover_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.dayHoverHandler($event));
    })("onHoverWeek", function BsDaterangepickerInlineContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onHoverWeek_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.weekHoverHandler($event));
    })("onSelect", function BsDaterangepickerInlineContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template_bs_days_calendar_view_onSelect_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.daySelectHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const calendar_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("bs-datepicker-multiple", ctx_r1.multipleCalendars);
    i0.ɵɵproperty("calendar", calendar_r4)("isDisabled", ctx_r1.isDatePickerDisabled)("options", i0.ɵɵpipeBind1(1, 5, ctx_r1.options$));
  }
}
function BsDaterangepickerInlineContainerComponent_div_0_ng_container_4_div_4_timepicker_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "timepicker", 15, 1);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", ctx_r1.isDatePickerDisabled);
  }
}
function BsDaterangepickerInlineContainerComponent_div_0_ng_container_4_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "timepicker", 15, 0);
    i0.ɵɵtemplate(3, BsDaterangepickerInlineContainerComponent_div_0_ng_container_4_div_4_timepicker_3_Template, 2, 1, "timepicker", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.isDatePickerDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isRangePicker);
  }
}
function BsDaterangepickerInlineContainerComponent_div_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵtemplate(2, BsDaterangepickerInlineContainerComponent_div_0_ng_container_4_bs_days_calendar_view_2_Template, 2, 7, "bs-days-calendar-view", 11);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, BsDaterangepickerInlineContainerComponent_div_0_ng_container_4_div_4_Template, 4, 2, "div", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(3, 2, ctx_r1.daysCalendar$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.withTimepicker);
  }
}
function BsDaterangepickerInlineContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "bs-month-calendar-view", 18);
    i0.ɵɵlistener("onNavigate", function BsDaterangepickerInlineContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template_bs_month_calendar_view_onNavigate_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.navigateTo($event));
    })("onViewMode", function BsDaterangepickerInlineContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template_bs_month_calendar_view_onViewMode_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setViewMode($event));
    })("onHover", function BsDaterangepickerInlineContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template_bs_month_calendar_view_onHover_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.monthHoverHandler($event));
    })("onSelect", function BsDaterangepickerInlineContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template_bs_month_calendar_view_onSelect_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.monthSelectHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const calendar_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("bs-datepicker-multiple", ctx_r1.multipleCalendars);
    i0.ɵɵproperty("calendar", calendar_r6);
  }
}
function BsDaterangepickerInlineContainerComponent_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, BsDaterangepickerInlineContainerComponent_div_0_div_5_bs_month_calendar_view_1_Template, 1, 3, "bs-month-calendar-view", 17);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r1.monthsCalendar));
  }
}
function BsDaterangepickerInlineContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "bs-years-calendar-view", 18);
    i0.ɵɵlistener("onNavigate", function BsDaterangepickerInlineContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template_bs_years_calendar_view_onNavigate_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.navigateTo($event));
    })("onViewMode", function BsDaterangepickerInlineContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template_bs_years_calendar_view_onViewMode_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setViewMode($event));
    })("onHover", function BsDaterangepickerInlineContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template_bs_years_calendar_view_onHover_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.yearHoverHandler($event));
    })("onSelect", function BsDaterangepickerInlineContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template_bs_years_calendar_view_onSelect_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.yearSelectHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const calendar_r8 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("bs-datepicker-multiple", ctx_r1.multipleCalendars);
    i0.ɵɵproperty("calendar", calendar_r8);
  }
}
function BsDaterangepickerInlineContainerComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, BsDaterangepickerInlineContainerComponent_div_0_div_6_bs_years_calendar_view_1_Template, 1, 3, "bs-years-calendar-view", 17);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r1.yearsCalendar));
  }
}
function BsDaterangepickerInlineContainerComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "button", 20);
    i0.ɵɵtext(2, "Apply");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 21);
    i0.ɵɵtext(4, "Cancel");
    i0.ɵɵelementEnd()();
  }
}
function BsDaterangepickerInlineContainerComponent_div_0_div_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "button", 25);
    i0.ɵɵlistener("click", function BsDaterangepickerInlineContainerComponent_div_0_div_8_div_1_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setToday());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("today-left", ctx_r1.todayPos === "left")("today-right", ctx_r1.todayPos === "right")("today-center", ctx_r1.todayPos === "center");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.todayBtnLbl);
  }
}
function BsDaterangepickerInlineContainerComponent_div_0_div_8_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "button", 25);
    i0.ɵɵlistener("click", function BsDaterangepickerInlineContainerComponent_div_0_div_8_div_2_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.clearDate());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("clear-left", ctx_r1.clearPos === "left")("clear-right", ctx_r1.clearPos === "right")("clear-center", ctx_r1.clearPos === "center");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.clearBtnLbl);
  }
}
function BsDaterangepickerInlineContainerComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, BsDaterangepickerInlineContainerComponent_div_0_div_8_div_1_Template, 3, 7, "div", 22)(2, BsDaterangepickerInlineContainerComponent_div_0_div_8_div_2_Template, 3, 7, "div", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showTodayBtn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showClearBtn);
  }
}
function BsDaterangepickerInlineContainerComponent_div_0_div_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "bs-custom-date-view", 28);
    i0.ɵɵlistener("onSelect", function BsDaterangepickerInlineContainerComponent_div_0_div_9_Template_bs_custom_date_view_onSelect_1_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.setRangeOnCalendar($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("selectedRange", ctx_r1.chosenRange)("ranges", ctx_r1.customRanges)("customRangeLabel", ctx_r1.customRangeBtnLbl);
  }
}
function BsDaterangepickerInlineContainerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵlistener("@datepickerAnimation.done", function BsDaterangepickerInlineContainerComponent_div_0_Template_div_animation_datepickerAnimation_done_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.positionServiceEnable());
    });
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵtemplate(4, BsDaterangepickerInlineContainerComponent_div_0_ng_container_4_Template, 5, 4, "ng-container", 6)(5, BsDaterangepickerInlineContainerComponent_div_0_div_5_Template, 3, 3, "div", 7)(6, BsDaterangepickerInlineContainerComponent_div_0_div_6_Template, 3, 3, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, BsDaterangepickerInlineContainerComponent_div_0_div_7_Template, 5, 0, "div", 8)(8, BsDaterangepickerInlineContainerComponent_div_0_div_8_Template, 3, 2, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, BsDaterangepickerInlineContainerComponent_div_0_div_9_Template, 2, 3, "div", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.containerClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("@datepickerAnimation", ctx_r1.animationState);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", i0.ɵɵpipeBind1(3, 9, ctx_r1.viewMode));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitchCase", "day");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "month");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "year");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showTodayBtn || ctx_r1.showClearBtn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.customRanges && ctx_r1.customRanges.length > 0);
  }
}
let BsDatepickerConfig = /*#__PURE__*/(() => {
  class BsDatepickerConfig {
    constructor() {
      /** sets use adaptive position */
      this.adaptivePosition = false;
      /** sets use UTC date time format */
      this.useUtc = false;
      /** turn on/off animation */
      this.isAnimated = false;
      /**
       * The view that the datepicker should start in
       */
      this.startView = 'day';
      /**
       * If true, returns focus to the datepicker / daterangepicker input after date selection
       */
      this.returnFocusToInput = false;
      /** CSS class which will be applied to datepicker container,
       * usually used to set color theme
       */
      this.containerClass = 'theme-green';
      // DatepickerRenderOptions
      this.displayMonths = 1;
      /**
       * Allows to hide week numbers in datepicker
       */
      this.showWeekNumbers = true;
      this.dateInputFormat = 'L';
      // range picker
      this.rangeSeparator = ' - ';
      /**
       * Date format for date range input field
       */
      this.rangeInputFormat = 'L';
      // DatepickerFormatOptions
      this.monthTitle = 'MMMM';
      this.yearTitle = 'YYYY';
      this.dayLabel = 'D';
      this.monthLabel = 'MMMM';
      this.yearLabel = 'YYYY';
      this.weekNumbers = 'w';
      /**
       * Shows 'today' button
       */
      this.showTodayButton = false;
      /**
       * Shows clear button
       */
      this.showClearButton = false;
      /**
       * Positioning of 'today' button
       */
      this.todayPosition = 'center';
      /**
       * Positioning of 'clear' button
       */
      this.clearPosition = 'right';
      /**
       * Label for 'today' button
       */
      this.todayButtonLabel = 'Today';
      /**
       * Label for 'clear' button
       */
      this.clearButtonLabel = 'Clear';
      /**
       * Label for 'custom range' button
       */
      this.customRangeButtonLabel = 'Custom Range';
      /**
       * Shows timepicker under datepicker
       */
      this.withTimepicker = false;
      /**
       * Set allowed positions of container.
       */
      this.allowedPositions = ['top', 'bottom'];
      /**
       * Set rule for datepicker closing. If value is true datepicker closes only if date is changed, if user changes only time datepicker doesn't close. It is available only if property withTimepicker is set true
       * */
      this.keepDatepickerOpened = false;
      /**
       * Allows keep invalid dates in range. Can be used with minDate, maxDate
       * */
      this.keepDatesOutOfRules = false;
    }
    static {
      this.ɵfac = function BsDatepickerConfig_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsDatepickerConfig)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BsDatepickerConfig,
        factory: BsDatepickerConfig.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BsDatepickerConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DATEPICKER_ANIMATION_TIMING = '220ms cubic-bezier(0, 0, 0.2, 1)';
const datepickerAnimation = trigger('datepickerAnimation', [state('animated-down', style({
  height: '*',
  overflow: 'hidden'
})), transition('* => animated-down', [style({
  height: 0,
  overflow: 'hidden'
}), animate(DATEPICKER_ANIMATION_TIMING)]), state('animated-up', style({
  height: '*',
  overflow: 'hidden'
})), transition('* => animated-up', [style({
  height: '*',
  overflow: 'hidden'
}), animate(DATEPICKER_ANIMATION_TIMING)]), transition('* => unanimated', animate('0s'))]);
class BsDatepickerAbstractComponent {
  constructor() {
    this.containerClass = '';
    this.customRanges = [];
    this.chosenRange = [];
    this._daysCalendarSub = new Subscription();
    this.selectedTimeSub = new Subscription();
  }
  set minDate(value) {
    this._effects?.setMinDate(value);
  }
  set maxDate(value) {
    this._effects?.setMaxDate(value);
  }
  set daysDisabled(value) {
    this._effects?.setDaysDisabled(value);
  }
  set datesDisabled(value) {
    this._effects?.setDatesDisabled(value);
  }
  set datesEnabled(value) {
    this._effects?.setDatesEnabled(value);
  }
  set isDisabled(value) {
    this._effects?.setDisabled(value);
  }
  set dateCustomClasses(value) {
    this._effects?.setDateCustomClasses(value);
  }
  set dateTooltipTexts(value) {
    this._effects?.setDateTooltipTexts(value);
  }
  set daysCalendar$(value) {
    this._daysCalendar$ = value;
    this._daysCalendarSub.unsubscribe();
    this._daysCalendarSub.add(this._daysCalendar$.subscribe(value => {
      this.multipleCalendars = !!value && value.length > 1;
    }));
  }
  get daysCalendar$() {
    return this._daysCalendar$;
  }
  // todo: valorkin fix
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  setViewMode(event) {}
  // eslint-disable-next-line
  navigateTo(event) {}
  // eslint-disable-next-line
  dayHoverHandler(event) {}
  // eslint-disable-next-line
  weekHoverHandler(event) {}
  // eslint-disable-next-line
  monthHoverHandler(event) {}
  // eslint-disable-next-line
  yearHoverHandler(event) {}
  // eslint-disable-next-line
  timeSelectHandler(date, index) {}
  // eslint-disable-next-line
  daySelectHandler(day) {}
  // eslint-disable-next-line
  monthSelectHandler(event) {}
  // eslint-disable-next-line
  yearSelectHandler(event) {}
  // eslint-disable-next-line
  setRangeOnCalendar(dates) {}
  // eslint-disable-next-line
  setToday() {}
  // eslint-disable-next-line
  clearDate() {}
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _stopPropagation(event) {
    event.stopPropagation();
  }
}
let BsDatepickerActions = /*#__PURE__*/(() => {
  class BsDatepickerActions {
    static {
      this.CALCULATE = '[datepicker] calculate dates matrix';
    }
    static {
      this.FORMAT = '[datepicker] format datepicker values';
    }
    static {
      this.FLAG = '[datepicker] set flags';
    }
    static {
      this.SELECT = '[datepicker] select date';
    }
    static {
      this.NAVIGATE_OFFSET = '[datepicker] shift view date';
    }
    static {
      this.NAVIGATE_TO = '[datepicker] change view date';
    }
    static {
      this.SET_OPTIONS = '[datepicker] update render options';
    }
    static {
      this.HOVER = '[datepicker] hover date';
    }
    static {
      this.CHANGE_VIEWMODE = '[datepicker] switch view mode';
    }
    static {
      this.SET_MIN_DATE = '[datepicker] set min date';
    }
    static {
      this.SET_MAX_DATE = '[datepicker] set max date';
    }
    static {
      this.SET_DAYSDISABLED = '[datepicker] set days disabled';
    }
    static {
      this.SET_DATESDISABLED = '[datepicker] set dates disabled';
    }
    static {
      this.SET_DATESENABLED = '[datepicker] set dates enabled';
    }
    static {
      this.SET_IS_DISABLED = '[datepicker] set is disabled';
    }
    static {
      this.SET_DATE_CUSTOM_CLASSES = '[datepicker] set date custom classes';
    }
    static {
      this.SET_DATE_TOOLTIP_TEXTS = '[datepicker] set date tooltip texts';
    }
    static {
      this.SET_LOCALE = '[datepicker] set datepicker locale';
    }
    static {
      this.SELECT_TIME = '[datepicker] select time';
    }
    static {
      this.SELECT_RANGE = '[daterangepicker] select dates range';
    }
    calculate() {
      return {
        type: BsDatepickerActions.CALCULATE
      };
    }
    format() {
      return {
        type: BsDatepickerActions.FORMAT
      };
    }
    flag() {
      return {
        type: BsDatepickerActions.FLAG
      };
    }
    select(date) {
      return {
        type: BsDatepickerActions.SELECT,
        payload: date
      };
    }
    selectTime(date, index) {
      return {
        type: BsDatepickerActions.SELECT_TIME,
        payload: {
          date,
          index
        }
      };
    }
    changeViewMode(event) {
      return {
        type: BsDatepickerActions.CHANGE_VIEWMODE,
        payload: event
      };
    }
    navigateTo(event) {
      return {
        type: BsDatepickerActions.NAVIGATE_TO,
        payload: event
      };
    }
    navigateStep(step) {
      return {
        type: BsDatepickerActions.NAVIGATE_OFFSET,
        payload: step
      };
    }
    setOptions(options) {
      return {
        type: BsDatepickerActions.SET_OPTIONS,
        payload: options
      };
    }
    // date range picker
    selectRange(value) {
      return {
        type: BsDatepickerActions.SELECT_RANGE,
        payload: value
      };
    }
    hoverDay(event) {
      return {
        type: BsDatepickerActions.HOVER,
        payload: event.isHovered ? event.cell.date : null
      };
    }
    minDate(date) {
      return {
        type: BsDatepickerActions.SET_MIN_DATE,
        payload: date
      };
    }
    maxDate(date) {
      return {
        type: BsDatepickerActions.SET_MAX_DATE,
        payload: date
      };
    }
    daysDisabled(days) {
      return {
        type: BsDatepickerActions.SET_DAYSDISABLED,
        payload: days
      };
    }
    datesDisabled(dates) {
      return {
        type: BsDatepickerActions.SET_DATESDISABLED,
        payload: dates
      };
    }
    datesEnabled(dates) {
      return {
        type: BsDatepickerActions.SET_DATESENABLED,
        payload: dates
      };
    }
    isDisabled(value) {
      return {
        type: BsDatepickerActions.SET_IS_DISABLED,
        payload: value
      };
    }
    setDateCustomClasses(value) {
      return {
        type: BsDatepickerActions.SET_DATE_CUSTOM_CLASSES,
        payload: value
      };
    }
    setDateTooltipTexts(value) {
      return {
        type: BsDatepickerActions.SET_DATE_TOOLTIP_TEXTS,
        payload: value
      };
    }
    setLocale(locale) {
      return {
        type: BsDatepickerActions.SET_LOCALE,
        payload: locale
      };
    }
    static {
      this.ɵfac = function BsDatepickerActions_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsDatepickerActions)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BsDatepickerActions,
        factory: BsDatepickerActions.ɵfac,
        providedIn: 'platform'
      });
    }
  }
  return BsDatepickerActions;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsLocaleService = /*#__PURE__*/(() => {
  class BsLocaleService {
    constructor() {
      this._defaultLocale = 'en';
      this._locale = new BehaviorSubject(this._defaultLocale);
      this._localeChange = this._locale.asObservable();
    }
    get locale() {
      return this._locale;
    }
    get localeChange() {
      return this._localeChange;
    }
    get currentLocale() {
      return this._locale.getValue();
    }
    use(locale) {
      if (locale === this.currentLocale) {
        return;
      }
      this._locale.next(locale);
    }
    static {
      this.ɵfac = function BsLocaleService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsLocaleService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BsLocaleService,
        factory: BsLocaleService.ɵfac,
        providedIn: 'platform'
      });
    }
  }
  return BsLocaleService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsDatepickerEffects = /*#__PURE__*/(() => {
  class BsDatepickerEffects {
    constructor(_actions, _localeService) {
      this._actions = _actions;
      this._localeService = _localeService;
      this._subs = [];
    }
    init(_bsDatepickerStore) {
      this._store = _bsDatepickerStore;
      return this;
    }
    /** setters */
    setValue(value) {
      this._store?.dispatch(this._actions.select(value));
    }
    setRangeValue(value) {
      this._store?.dispatch(this._actions.selectRange(value));
    }
    setMinDate(value) {
      this._store?.dispatch(this._actions.minDate(value));
      return this;
    }
    setMaxDate(value) {
      this._store?.dispatch(this._actions.maxDate(value));
      return this;
    }
    setDaysDisabled(value) {
      this._store?.dispatch(this._actions.daysDisabled(value));
      return this;
    }
    setDatesDisabled(value) {
      this._store?.dispatch(this._actions.datesDisabled(value));
      return this;
    }
    setDatesEnabled(value) {
      this._store?.dispatch(this._actions.datesEnabled(value));
      return this;
    }
    setDisabled(value) {
      this._store?.dispatch(this._actions.isDisabled(value));
      return this;
    }
    setDateCustomClasses(value) {
      this._store?.dispatch(this._actions.setDateCustomClasses(value));
      return this;
    }
    setDateTooltipTexts(value) {
      this._store?.dispatch(this._actions.setDateTooltipTexts(value));
      return this;
    }
    /* Set rendering options */
    setOptions(_config) {
      const _options = Object.assign({
        locale: this._localeService.currentLocale
      }, _config);
      this._store?.dispatch(this._actions.setOptions(_options));
      return this;
    }
    /** view to mode bindings */
    setBindings(container) {
      if (!this._store) {
        return this;
      }
      container.selectedTime = this._store.select(state => state.selectedTime).pipe(filter(times => !!times));
      container.daysCalendar$ = this._store.select(state => state.flaggedMonths).pipe(filter(months => !!months));
      // month calendar
      container.monthsCalendar = this._store.select(state => state.flaggedMonthsCalendar).pipe(filter(months => !!months));
      // year calendar
      container.yearsCalendar = this._store.select(state => state.yearsCalendarFlagged).pipe(filter(years => !!years));
      container.viewMode = this._store.select(state => state.view?.mode);
      container.options$ = combineLatest([this._store.select(state => state.showWeekNumbers), this._store.select(state => state.displayMonths)]).pipe(map(latest => ({
        showWeekNumbers: latest[0],
        displayMonths: latest[1]
      })));
      return this;
    }
    /** event handlers */
    setEventHandlers(container) {
      container.setViewMode = event => {
        this._store?.dispatch(this._actions.changeViewMode(event));
      };
      container.navigateTo = event => {
        this._store?.dispatch(this._actions.navigateStep(event.step));
      };
      container.dayHoverHandler = event => {
        const _cell = event.cell;
        if (_cell.isOtherMonth || _cell.isDisabled) {
          return;
        }
        this._store?.dispatch(this._actions.hoverDay(event));
        _cell.isHovered = event.isHovered;
      };
      container.monthHoverHandler = event => {
        event.cell.isHovered = event.isHovered;
      };
      container.yearHoverHandler = event => {
        event.cell.isHovered = event.isHovered;
      };
      return this;
    }
    registerDatepickerSideEffects() {
      if (!this._store) {
        return this;
      }
      this._subs.push(this._store.select(state => state.view).subscribe(() => {
        this._store?.dispatch(this._actions.calculate());
      }));
      // format calendar values on month model change
      this._subs.push(this._store.select(state => state.monthsModel).pipe(filter(monthModel => !!monthModel)).subscribe(() => this._store?.dispatch(this._actions.format())));
      // flag day values
      this._subs.push(this._store.select(state => state.formattedMonths).pipe(filter(month => !!month)).subscribe(() => this._store?.dispatch(this._actions.flag())));
      // flag day values
      this._subs.push(this._store.select(state => state.selectedDate).pipe(filter(selectedDate => !!selectedDate)).subscribe(() => this._store?.dispatch(this._actions.flag())));
      // flag for date range picker
      this._subs.push(this._store.select(state => state.selectedRange).pipe(filter(selectedRange => !!selectedRange)).subscribe(() => this._store?.dispatch(this._actions.flag())));
      // monthsCalendar
      this._subs.push(this._store.select(state => state.monthsCalendar).subscribe(() => this._store?.dispatch(this._actions.flag())));
      // years calendar
      this._subs.push(this._store.select(state => state.yearsCalendarModel).pipe(filter(state => !!state)).subscribe(() => this._store?.dispatch(this._actions.flag())));
      // on hover
      this._subs.push(this._store.select(state => state.hoveredDate).pipe(filter(hoveredDate => !!hoveredDate)).subscribe(() => this._store?.dispatch(this._actions.flag())));
      // date custom classes
      this._subs.push(this._store.select(state => state.dateCustomClasses).pipe(filter(dateCustomClasses => !!dateCustomClasses)).subscribe(() => this._store?.dispatch(this._actions.flag())));
      // date tooltip texts
      this._subs.push(this._store.select(state => state.dateTooltipTexts).pipe(filter(dateTooltipTexts => !!dateTooltipTexts)).subscribe(() => this._store?.dispatch(this._actions.flag())));
      // on locale change
      this._subs.push(this._localeService.localeChange.subscribe(locale => this._store?.dispatch(this._actions.setLocale(locale))));
      return this;
    }
    destroy() {
      for (const sub of this._subs) {
        sub.unsubscribe();
      }
    }
    static {
      this.ɵfac = function BsDatepickerEffects_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsDatepickerEffects)(i0.ɵɵinject(BsDatepickerActions), i0.ɵɵinject(BsLocaleService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BsDatepickerEffects,
        factory: BsDatepickerEffects.ɵfac,
        providedIn: 'platform'
      });
    }
  }
  return BsDatepickerEffects;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const defaultMonthOptions = {
  width: 7,
  height: 6
};
const dayInMilliseconds = 24 * 60 * 60 * 1000;
class BsDatepickerState {
  constructor() {
    // DatepickerRenderOptions
    this.showWeekNumbers = true;
    this.displayMonths = 1;
  }
}
const _initialView = {
  date: new Date(),
  mode: 'day'
};
const initialDatepickerState = Object.assign(new BsDatepickerConfig(), {
  locale: 'en',
  view: _initialView,
  selectedRange: [],
  selectedTime: [],
  monthViewOptions: defaultMonthOptions
});
function getStartingDayOfCalendar(date, options) {
  if (isFirstDayOfWeek(date, options.firstDayOfWeek)) {
    return date;
  }
  const weekDay = getDay(date);
  const offset = calculateDateOffset(weekDay, options.firstDayOfWeek);
  return shiftDate(date, {
    day: -offset
  });
}
function calculateDateOffset(weekday, startingDayOffset) {
  const _startingDayOffset = Number(startingDayOffset);
  if (isNaN(_startingDayOffset)) {
    return 0;
  }
  if (_startingDayOffset === 0) {
    return weekday;
  }
  const offset = weekday - _startingDayOffset % 7;
  return offset < 0 ? offset + 7 : offset;
}
function isMonthDisabled(date, min, max) {
  const minBound = min && isBefore(endOf(date, 'month'), min, 'day');
  const maxBound = max && isAfter(startOf(date, 'month'), max, 'day');
  return minBound || maxBound || false;
}
function isYearDisabled(date, min, max) {
  const minBound = min && isBefore(endOf(date, 'year'), min, 'day');
  const maxBound = max && isAfter(startOf(date, 'year'), max, 'day');
  return minBound || maxBound || false;
}
function isDisabledDate(date, datesDisabled, unit) {
  if (!datesDisabled || !isArray(datesDisabled) || !datesDisabled.length) {
    return false;
  }
  if (unit && unit === 'year' && !datesDisabled[0].getDate()) {
    return datesDisabled.some(dateDisabled => isSame(date, dateDisabled, 'year'));
  }
  return datesDisabled.some(dateDisabled => isSame(date, dateDisabled, 'date'));
}
function isEnabledDate(date, datesEnabled, unit) {
  if (!datesEnabled || !isArray(datesEnabled) || !datesEnabled.length) {
    return false;
  }
  return !datesEnabled.some(enabledDate => isSame(date, enabledDate, unit || 'date'));
}
function getYearsCalendarInitialDate(state, calendarIndex = 0) {
  const model = state && state.yearsCalendarModel && state.yearsCalendarModel[calendarIndex];
  return model?.years[0] && model.years[0][0] && model.years[0][0].date;
}
function checkRangesWithMaxDate(ranges, maxDate) {
  if (!ranges) return ranges;
  if (!maxDate) return ranges;
  if (!ranges.length && !ranges[0].value) return ranges;
  ranges.forEach(item => {
    if (!item || !item.value) return ranges;
    if (item.value instanceof Date) return ranges;
    if (!(item.value instanceof Array && item.value.length)) return ranges;
    item.value = compareDateWithMaxDateHelper(item.value, maxDate);
    return ranges;
  });
  return ranges;
}
function checkBsValue(date, maxDate) {
  if (!date) return date;
  if (!maxDate) return date;
  if (date instanceof Array && !date.length) return date;
  if (date instanceof Date) return date;
  return compareDateWithMaxDateHelper(date, maxDate);
}
function compareDateWithMaxDateHelper(date, maxDate) {
  if (date instanceof Array) {
    const editedValues = date.map(item => {
      if (!item) return item;
      if (isAfter(item, maxDate, 'date')) item = maxDate;
      return item;
    });
    return editedValues;
  }
  return date;
}
function setCurrentTimeOnDateSelect(value) {
  if (!value) return value;
  return setCurrentTimeHelper(value);
}
function setDateRangesCurrentTimeOnDateSelect(value) {
  if (!value?.length) return value;
  value.map(date => {
    if (!date) {
      return date;
    }
    return setCurrentTimeHelper(date);
  });
  return value;
}
function setCurrentTimeHelper(date) {
  const now = new Date();
  date.setMilliseconds(now.getMilliseconds());
  date.setSeconds(now.getSeconds());
  date.setMinutes(now.getMinutes());
  date.setHours(now.getHours());
  return date;
}
function createMatrix(options, fn) {
  let prevValue = options.initialDate;
  const matrix = new Array(options.height);
  for (let i = 0; i < options.height; i++) {
    matrix[i] = new Array(options.width);
    for (let j = 0; j < options.width; j++) {
      matrix[i][j] = fn(prevValue);
      prevValue = shiftDate(prevValue, options.shift);
    }
  }
  return matrix;
}

// user and model input should handle parsing and validating input values
function calcDaysCalendar(startingDate, options) {
  const firstDay = getFirstDayOfMonth(startingDate);
  const initialDate = getStartingDayOfCalendar(firstDay, options);
  // todo test
  const matrixOptions = {
    width: options.width || 0,
    height: options.height || 0,
    initialDate,
    shift: {
      day: 1
    }
  };
  const daysMatrix = createMatrix(matrixOptions, date => date);
  return {
    daysMatrix,
    month: firstDay
  };
}
function formatDaysCalendar(daysCalendar, formatOptions, monthIndex) {
  return {
    month: daysCalendar.month,
    monthTitle: formatDate(daysCalendar.month, formatOptions.monthTitle, formatOptions.locale),
    yearTitle: formatDate(daysCalendar.month, formatOptions.yearTitle, formatOptions.locale),
    weekNumbers: getWeekNumbers(daysCalendar.daysMatrix, formatOptions.weekNumbers, formatOptions.locale),
    weekdays: getShiftedWeekdays(formatOptions.locale),
    weeks: daysCalendar.daysMatrix.map((week, weekIndex) => ({
      days: week.map((date, dayIndex) => ({
        date,
        label: formatDate(date, formatOptions.dayLabel, formatOptions.locale),
        monthIndex,
        weekIndex,
        dayIndex
      }))
    })),
    hideLeftArrow: false,
    hideRightArrow: false,
    disableLeftArrow: false,
    disableRightArrow: false
  };
}
function getWeekNumbers(daysMatrix, format, locale) {
  return daysMatrix.map(days => days[0] ? formatDate(days[0], format, locale) : '');
}
function getShiftedWeekdays(locale) {
  const _locale = getLocale(locale);
  const weekdays = _locale.weekdaysShort();
  const firstDayOfWeek = _locale.firstDayOfWeek();
  return [...weekdays.slice(firstDayOfWeek), ...weekdays.slice(0, firstDayOfWeek)];
}
function flagDaysCalendar(formattedMonth, options) {
  formattedMonth.weeks.forEach(week => {
    week.days.forEach((day, dayIndex) => {
      // datepicker
      const isOtherMonth = !isSameMonth(day.date, formattedMonth.month);
      const isHovered = !isOtherMonth && isSameDay(day.date, options.hoveredDate);
      // date range picker
      const isSelectionStart = !isOtherMonth && options.selectedRange && isSameDay(day.date, options.selectedRange[0]);
      const isSelectionEnd = !isOtherMonth && options.selectedRange && isSameDay(day.date, options.selectedRange[1]);
      const isSelected = !isOtherMonth && isSameDay(day.date, options.selectedDate) || isSelectionStart || isSelectionEnd;
      const isInRange = !isOtherMonth && options.selectedRange && isDateInRange(day.date, options.selectedRange, options.hoveredDate);
      const isDisabled = options.isDisabled || isBefore(day.date, options.minDate, 'day') || isAfter(day.date, options.maxDate, 'day') || isDisabledDay(day.date, options.daysDisabled) || isDisabledDate(day.date, options.datesDisabled) || isEnabledDate(day.date, options.datesEnabled);
      const currentDate = new Date();
      const isToday = !isOtherMonth && isSameDay(day.date, currentDate);
      const customClasses = options.dateCustomClasses && options.dateCustomClasses.map(dcc => isSameDay(day.date, dcc.date) ? dcc.classes : []).reduce((previousValue, currentValue) => previousValue.concat(currentValue), []).join(' ') || '';
      const tooltipText = options.dateTooltipTexts && options.dateTooltipTexts.map(tt => isSameDay(day.date, tt.date) ? tt.tooltipText : '').reduce((previousValue, currentValue) => {
        previousValue.push(currentValue);
        return previousValue;
      }, []).join(' ') || '';
      // decide update or not
      const newDay = Object.assign({}, day, {
        isOtherMonth,
        isHovered,
        isSelected,
        isSelectionStart,
        isSelectionEnd,
        isInRange,
        isDisabled,
        isToday,
        customClasses,
        tooltipText
      });
      if (day.isOtherMonth !== newDay.isOtherMonth || day.isHovered !== newDay.isHovered || day.isSelected !== newDay.isSelected || day.isSelectionStart !== newDay.isSelectionStart || day.isSelectionEnd !== newDay.isSelectionEnd || day.isDisabled !== newDay.isDisabled || day.isInRange !== newDay.isInRange || day.customClasses !== newDay.customClasses || day.tooltipText !== newDay.tooltipText) {
        week.days[dayIndex] = newDay;
      }
    });
  });
  // todo: add check for linked calendars
  formattedMonth.hideLeftArrow = options.isDisabled || !!options.monthIndex && options.monthIndex > 0 && options.monthIndex !== options.displayMonths;
  formattedMonth.hideRightArrow = options.isDisabled || (!!options.monthIndex || options.monthIndex === 0) && !!options.displayMonths && options.monthIndex < options.displayMonths && options.monthIndex + 1 !== options.displayMonths;
  formattedMonth.disableLeftArrow = isMonthDisabled(shiftDate(formattedMonth.month, {
    month: -1
  }), options.minDate, options.maxDate);
  formattedMonth.disableRightArrow = isMonthDisabled(shiftDate(formattedMonth.month, {
    month: 1
  }), options.minDate, options.maxDate);
  return formattedMonth;
}
function isDateInRange(date, selectedRange, hoveredDate) {
  if (!date || !selectedRange || !selectedRange[0]) {
    return false;
  }
  if (selectedRange[1]) {
    return date > selectedRange[0] && date <= selectedRange[1];
  }
  if (hoveredDate) {
    return date > selectedRange[0] && date <= hoveredDate;
  }
  return false;
}
function canSwitchMode(mode, minMode) {
  return minMode ? mode >= minMode : true;
}
const height$1 = 4;
const width$1 = 3;
const shift$1 = {
  month: 1
};
function formatMonthsCalendar(viewDate, formatOptions) {
  const initialDate = startOf(viewDate, 'year');
  const matrixOptions = {
    width: width$1,
    height: height$1,
    initialDate,
    shift: shift$1
  };
  const monthMatrix = createMatrix(matrixOptions, date => ({
    date,
    label: formatDate(date, formatOptions.monthLabel, formatOptions.locale)
  }));
  return {
    months: monthMatrix,
    monthTitle: '',
    yearTitle: formatDate(viewDate, formatOptions.yearTitle, formatOptions.locale),
    hideRightArrow: false,
    hideLeftArrow: false,
    disableRightArrow: false,
    disableLeftArrow: false
  };
}
function flagMonthsCalendar(monthCalendar, options) {
  monthCalendar.months.forEach((months, rowIndex) => {
    months.forEach((month, monthIndex) => {
      let isSelected;
      const isHovered = isSameMonth(month.date, options.hoveredMonth);
      const isDisabled = options.isDisabled || isDisabledDate(month.date, options.datesDisabled) || isEnabledDate(month.date, options.datesEnabled, 'month') || isMonthDisabled(month.date, options.minDate, options.maxDate);
      if (!options.selectedDate && options.selectedRange) {
        isSelected = isSameMonth(month.date, options.selectedRange[0]);
        if (!isSelected) {
          isSelected = isSameMonth(month.date, options.selectedRange[1]);
        }
      } else {
        isSelected = isSameMonth(month.date, options.selectedDate);
      }
      const newMonth = Object.assign( /*{},*/month, {
        isHovered,
        isDisabled,
        isSelected
      });
      if (month.isHovered !== newMonth.isHovered || month.isDisabled !== newMonth.isDisabled || month.isSelected !== newMonth.isSelected) {
        monthCalendar.months[rowIndex][monthIndex] = newMonth;
      }
    });
  });
  // todo: add check for linked calendars
  monthCalendar.hideLeftArrow = !!options.monthIndex && options.monthIndex > 0 && options.monthIndex !== options.displayMonths;
  monthCalendar.hideRightArrow = (!!options.monthIndex || options.monthIndex === 0) && (!!options.displayMonths || options.displayMonths === 0) && options.monthIndex < options.displayMonths && options.monthIndex + 1 !== options.displayMonths;
  monthCalendar.disableLeftArrow = isYearDisabled(shiftDate(monthCalendar.months[0][0].date, {
    year: -1
  }), options.minDate, options.maxDate);
  monthCalendar.disableRightArrow = isYearDisabled(shiftDate(monthCalendar.months[0][0].date, {
    year: 1
  }), options.minDate, options.maxDate);
  return monthCalendar;
}
const height = 4;
const width = 4;
const yearsPerCalendar = height * width;
const initialYearShift = (Math.floor(yearsPerCalendar / 2) - 1) * -1;
const shift = {
  year: 1
};
function formatYearsCalendar(viewDate, formatOptions, previousInitialDate) {
  const initialDate = calculateInitialDate(viewDate, previousInitialDate);
  const matrixOptions = {
    width,
    height,
    initialDate,
    shift
  };
  const yearsMatrix = createMatrix(matrixOptions, date => ({
    date,
    label: formatDate(date, formatOptions.yearLabel, formatOptions.locale)
  }));
  const yearTitle = formatYearRangeTitle(yearsMatrix, formatOptions);
  return {
    years: yearsMatrix,
    monthTitle: '',
    yearTitle,
    hideLeftArrow: false,
    hideRightArrow: false,
    disableLeftArrow: false,
    disableRightArrow: false
  };
}
function calculateInitialDate(viewDate, previousInitialDate) {
  if (previousInitialDate && viewDate.getFullYear() >= previousInitialDate.getFullYear() && viewDate.getFullYear() < previousInitialDate.getFullYear() + yearsPerCalendar) {
    return previousInitialDate;
  }
  return shiftDate(viewDate, {
    year: initialYearShift
  });
}
function formatYearRangeTitle(yearsMatrix, formatOptions) {
  const from = formatDate(yearsMatrix[0][0].date, formatOptions.yearTitle, formatOptions.locale);
  const to = formatDate(yearsMatrix[height - 1][width - 1].date, formatOptions.yearTitle, formatOptions.locale);
  return `${from} - ${to}`;
}
function flagYearsCalendar(yearsCalendar, options) {
  yearsCalendar.years.forEach((years, rowIndex) => {
    years.forEach((year, yearIndex) => {
      let isSelected;
      const isHovered = isSameYear(year.date, options.hoveredYear);
      const isDisabled = options.isDisabled || isDisabledDate(year.date, options.datesDisabled, 'year') || isEnabledDate(year.date, options.datesEnabled, 'year') || isYearDisabled(year.date, options.minDate, options.maxDate);
      if (!options.selectedDate && options.selectedRange) {
        isSelected = isSameYear(year.date, options.selectedRange[0]);
        if (!isSelected) {
          isSelected = isSameYear(year.date, options.selectedRange[1]);
        }
      } else {
        isSelected = isSameYear(year.date, options.selectedDate);
      }
      const newMonth = Object.assign( /*{},*/year, {
        isHovered,
        isDisabled,
        isSelected
      });
      if (year.isHovered !== newMonth.isHovered || year.isDisabled !== newMonth.isDisabled || year.isSelected !== newMonth.isSelected) {
        yearsCalendar.years[rowIndex][yearIndex] = newMonth;
      }
    });
  });
  // todo: add check for linked calendars
  yearsCalendar.hideLeftArrow = !!options.yearIndex && options.yearIndex > 0 && options.yearIndex !== options.displayMonths;
  yearsCalendar.hideRightArrow = !!options.yearIndex && !!options.displayMonths && options.yearIndex < options.displayMonths && options.yearIndex + 1 !== options.displayMonths;
  yearsCalendar.disableLeftArrow = isYearDisabled(shiftDate(yearsCalendar.years[0][0].date, {
    year: -1
  }), options.minDate, options.maxDate);
  const i = yearsCalendar.years.length - 1;
  const j = yearsCalendar.years[i].length - 1;
  yearsCalendar.disableRightArrow = isYearDisabled(shiftDate(yearsCalendar.years[i][j].date, {
    year: 1
  }), options.minDate, options.maxDate);
  return yearsCalendar;
}
function copyTime(sourceDate, time) {
  if (!sourceDate || !isNaN(sourceDate.getTime())) {
    return;
  }
  sourceDate.setHours(time.getHours());
  sourceDate.setMinutes(time.getMinutes());
  sourceDate.setSeconds(time.getSeconds());
  sourceDate.setMilliseconds(time.getMilliseconds());
}
function bsDatepickerReducer(state = initialDatepickerState, action) {
  switch (action.type) {
    case BsDatepickerActions.CALCULATE:
      {
        return calculateReducer(state);
      }
    case BsDatepickerActions.FORMAT:
      {
        return formatReducer(state);
      }
    case BsDatepickerActions.FLAG:
      {
        return flagReducer(state);
      }
    case BsDatepickerActions.NAVIGATE_OFFSET:
      {
        return navigateOffsetReducer(state, action);
      }
    case BsDatepickerActions.NAVIGATE_TO:
      {
        const payload = action.payload;
        if (!state.view || !payload.unit) {
          return state;
        }
        const date = setFullDate(state.view.date, payload.unit);
        let newState;
        let mode;
        if (canSwitchMode(payload.viewMode, state.minMode)) {
          mode = payload.viewMode;
          newState = {
            view: {
              date,
              mode
            }
          };
        } else {
          mode = state.view.mode;
          newState = {
            selectedDate: date,
            view: {
              date,
              mode
            }
          };
        }
        return Object.assign({}, state, newState);
      }
    case BsDatepickerActions.CHANGE_VIEWMODE:
      {
        if (!canSwitchMode(action.payload, state.minMode) || !state.view) {
          return state;
        }
        const date = state.view.date;
        const mode = action.payload;
        const newState = {
          view: {
            date,
            mode
          }
        };
        return Object.assign({}, state, newState);
      }
    case BsDatepickerActions.HOVER:
      {
        return Object.assign({}, state, {
          hoveredDate: action.payload
        });
      }
    case BsDatepickerActions.SELECT:
      {
        if (!state.view) {
          return state;
        }
        const newState = {
          selectedDate: action.payload,
          view: state.view
        };
        if (Array.isArray(state.selectedTime)) {
          const _time = state.selectedTime[0];
          if (newState.selectedDate && _time) {
            copyTime(newState.selectedDate, _time);
          }
        }
        const mode = state.view.mode;
        const _date = action.payload || state.view.date;
        const date = getViewDate(_date, state.minDate, state.maxDate);
        newState.view = {
          mode,
          date
        };
        return Object.assign({}, state, newState);
      }
    case BsDatepickerActions.SELECT_TIME:
      {
        const {
          date,
          index
        } = action.payload;
        const selectedTime = state.selectedTime ? [...state.selectedTime] : [];
        selectedTime[index] = date;
        return Object.assign({}, state, {
          selectedTime
        });
      }
    case BsDatepickerActions.SET_OPTIONS:
      {
        if (!state.view) {
          return state;
        }
        const newState = action.payload;
        // preserve view mode
        const mode = newState.minMode ? newState.minMode : state.view.mode;
        const _viewDate = isDateValid(newState.value) && newState.value || isArray(newState.value) && isDateValid(newState.value[0]) && newState.value[0] || state.view.date;
        const date = getViewDate(_viewDate, newState.minDate, newState.maxDate);
        newState.view = {
          mode,
          date
        };
        // update selected value
        if (newState.value) {
          // if new value is array we work with date range
          if (isArray(newState.value)) {
            newState.selectedRange = newState.value;
            newState.selectedTime = newState.value.map(i => i);
          }
          // if new value is a date -> datepicker
          if (newState.value instanceof Date) {
            newState.selectedDate = newState.value;
            newState.selectedTime = [newState.value];
          }
          // provided value is not supported :)
          // need to report it somehow
        }
        return Object.assign({}, state, newState);
      }
    // date range picker
    case BsDatepickerActions.SELECT_RANGE:
      {
        if (!state.view) {
          return state;
        }
        const newState = {
          selectedRange: action.payload,
          view: state.view
        };
        newState.selectedRange?.forEach((dte, index) => {
          if (Array.isArray(state.selectedTime)) {
            const _time = state.selectedTime[index];
            if (_time) {
              copyTime(dte, _time);
            }
          }
        });
        const mode = state.view.mode;
        const _date = action.payload && action.payload[0] || state.view.date;
        const date = getViewDate(_date, state.minDate, state.maxDate);
        newState.view = {
          mode,
          date
        };
        return Object.assign({}, state, newState);
      }
    case BsDatepickerActions.SET_MIN_DATE:
      {
        return Object.assign({}, state, {
          minDate: action.payload
        });
      }
    case BsDatepickerActions.SET_MAX_DATE:
      {
        return Object.assign({}, state, {
          maxDate: action.payload
        });
      }
    case BsDatepickerActions.SET_IS_DISABLED:
      {
        return Object.assign({}, state, {
          isDisabled: action.payload
        });
      }
    case BsDatepickerActions.SET_DATE_CUSTOM_CLASSES:
      {
        return Object.assign({}, state, {
          dateCustomClasses: action.payload
        });
      }
    case BsDatepickerActions.SET_DATE_TOOLTIP_TEXTS:
      {
        return Object.assign({}, state, {
          dateTooltipTexts: action.payload
        });
      }
    default:
      return state;
  }
}
function calculateReducer(state) {
  if (!state.view) {
    return state;
  }
  // how many calendars
  let displayMonths;
  if (state.displayOneMonthRange && isDisplayOneMonth(state.view.date, state.minDate, state.maxDate)) {
    displayMonths = 1;
  } else {
    displayMonths = state.displayMonths || 1;
  }
  // use selected date on initial rendering if set
  let viewDate = state.view.date;
  if (state.view.mode === 'day' && state.monthViewOptions) {
    if (state.showPreviousMonth && state.selectedRange && state.selectedRange.length === 0) {
      viewDate = shiftDate(viewDate, {
        month: -1
      });
    }
    state.monthViewOptions.firstDayOfWeek = getLocale(state.locale).firstDayOfWeek();
    let monthsModel = new Array(displayMonths);
    for (let monthIndex = 0; monthIndex < displayMonths; monthIndex++) {
      // todo: for unlinked calendars it will be harder
      monthsModel[monthIndex] = calcDaysCalendar(viewDate, state.monthViewOptions);
      viewDate = shiftDate(viewDate, {
        month: 1
      });
    }
    // Check if parameter enabled and check if it's not months navigation event
    if (state.preventChangeToNextMonth && state.flaggedMonths && state.hoveredDate) {
      const viewMonth = calcDaysCalendar(state.view.date, state.monthViewOptions);
      // Check if viewed right month same as in flaggedMonths state, then override months model with flaggedMonths
      if (state.flaggedMonths.length && state.flaggedMonths[1].month.getMonth() === viewMonth.month.getMonth()) {
        monthsModel = state.flaggedMonths.map(item => {
          if (state.monthViewOptions) {
            return calcDaysCalendar(item.month, state.monthViewOptions);
          }
          return null;
        }).filter(item => item !== null);
      }
    }
    return Object.assign({}, state, {
      monthsModel
    });
  }
  if (state.view.mode === 'month') {
    const monthsCalendar = new Array(displayMonths);
    for (let calendarIndex = 0; calendarIndex < displayMonths; calendarIndex++) {
      // todo: for unlinked calendars it will be harder
      monthsCalendar[calendarIndex] = formatMonthsCalendar(viewDate, getFormatOptions(state));
      viewDate = shiftDate(viewDate, {
        year: 1
      });
    }
    return Object.assign({}, state, {
      monthsCalendar
    });
  }
  if (state.view.mode === 'year') {
    const yearsCalendarModel = new Array(displayMonths);
    for (let calendarIndex = 0; calendarIndex < displayMonths; calendarIndex++) {
      // todo: for unlinked calendars it will be harder
      yearsCalendarModel[calendarIndex] = formatYearsCalendar(viewDate, getFormatOptions(state), state.minMode === 'year' ? getYearsCalendarInitialDate(state, calendarIndex) : undefined);
      viewDate = shiftDate(viewDate, {
        year: yearsPerCalendar
      });
    }
    return Object.assign({}, state, {
      yearsCalendarModel
    });
  }
  return state;
}
function formatReducer(state) {
  if (!state.view) {
    return state;
  }
  if (state.view.mode === 'day' && state.monthsModel) {
    const formattedMonths = state.monthsModel.map((month, monthIndex) => formatDaysCalendar(month, getFormatOptions(state), monthIndex));
    return Object.assign({}, state, {
      formattedMonths
    });
  }
  // how many calendars
  const displayMonths = state.displayMonths || 1;
  // check initial rendering
  // use selected date on initial rendering if set
  let viewDate = state.view.date;
  if (state.view.mode === 'month') {
    const monthsCalendar = new Array(displayMonths);
    for (let calendarIndex = 0; calendarIndex < displayMonths; calendarIndex++) {
      // todo: for unlinked calendars it will be harder
      monthsCalendar[calendarIndex] = formatMonthsCalendar(viewDate, getFormatOptions(state));
      viewDate = shiftDate(viewDate, {
        year: 1
      });
    }
    return Object.assign({}, state, {
      monthsCalendar
    });
  }
  if (state.view.mode === 'year') {
    const yearsCalendarModel = new Array(displayMonths);
    for (let calendarIndex = 0; calendarIndex < displayMonths; calendarIndex++) {
      // todo: for unlinked calendars it will be harder
      yearsCalendarModel[calendarIndex] = formatYearsCalendar(viewDate, getFormatOptions(state));
      viewDate = shiftDate(viewDate, {
        year: 16
      });
    }
    return Object.assign({}, state, {
      yearsCalendarModel
    });
  }
  return state;
}
function flagReducer(state) {
  if (!state.view) {
    return state;
  }
  const displayMonths = isDisplayOneMonth(state.view.date, state.minDate, state.maxDate) ? 1 : state.displayMonths;
  if (state.formattedMonths && state.view.mode === 'day') {
    const flaggedMonths = state.formattedMonths.map((formattedMonth, monthIndex) => flagDaysCalendar(formattedMonth, {
      isDisabled: state.isDisabled,
      minDate: state.minDate,
      maxDate: state.maxDate,
      daysDisabled: state.daysDisabled,
      datesDisabled: state.datesDisabled,
      datesEnabled: state.datesEnabled,
      hoveredDate: state.hoveredDate,
      selectedDate: state.selectedDate,
      selectedRange: state.selectedRange,
      displayMonths,
      dateCustomClasses: state.dateCustomClasses,
      dateTooltipTexts: state.dateTooltipTexts,
      monthIndex
    }));
    return Object.assign({}, state, {
      flaggedMonths
    });
  }
  if (state.view.mode === 'month' && state.monthsCalendar) {
    const flaggedMonthsCalendar = state.monthsCalendar.map((formattedMonth, monthIndex) => flagMonthsCalendar(formattedMonth, {
      isDisabled: state.isDisabled,
      minDate: state.minDate,
      maxDate: state.maxDate,
      hoveredMonth: state.hoveredMonth,
      selectedDate: state.selectedDate,
      datesDisabled: state.datesDisabled,
      datesEnabled: state.datesEnabled,
      selectedRange: state.selectedRange,
      displayMonths,
      monthIndex
    }));
    return Object.assign({}, state, {
      flaggedMonthsCalendar
    });
  }
  if (state.view.mode === 'year' && state.yearsCalendarModel) {
    const yearsCalendarFlagged = state.yearsCalendarModel.map((formattedMonth, yearIndex) => flagYearsCalendar(formattedMonth, {
      isDisabled: state.isDisabled,
      minDate: state.minDate,
      maxDate: state.maxDate,
      hoveredYear: state.hoveredYear,
      selectedDate: state.selectedDate,
      datesDisabled: state.datesDisabled,
      datesEnabled: state.datesEnabled,
      selectedRange: state.selectedRange,
      displayMonths,
      yearIndex
    }));
    return Object.assign({}, state, {
      yearsCalendarFlagged
    });
  }
  return state;
}
function navigateOffsetReducer(state, action) {
  if (!state.view) {
    return state;
  }
  const date = shiftViewDate(state, action);
  if (!date) {
    return state;
  }
  const newState = {
    view: {
      mode: state.view.mode,
      date
    }
  };
  return Object.assign({}, state, newState);
}
function shiftViewDate(state, action) {
  if (!state.view) {
    return undefined;
  }
  if (state.view.mode === 'year' && state.minMode === 'year') {
    const initialDate = getYearsCalendarInitialDate(state, 0);
    if (initialDate) {
      const middleDate = shiftDate(initialDate, {
        year: -initialYearShift
      });
      return shiftDate(middleDate, action.payload);
    }
  }
  return shiftDate(startOf(state.view.date, 'month'), action.payload);
}
function getFormatOptions(state) {
  return {
    locale: state.locale,
    monthTitle: state.monthTitle,
    yearTitle: state.yearTitle,
    dayLabel: state.dayLabel,
    monthLabel: state.monthLabel,
    yearLabel: state.yearLabel,
    weekNumbers: state.weekNumbers
  };
}
/**
 * if view date is provided (bsValue|ngModel) it should be shown
 * if view date is not provider:
 * if minDate>currentDate (default view value), show minDate
 * if maxDate<currentDate(default view value) show maxDate
 */
function getViewDate(viewDate, minDate, maxDate) {
  const _date = Array.isArray(viewDate) ? viewDate[0] : viewDate;
  if (minDate && isAfter(minDate, _date, 'day')) {
    return minDate;
  }
  if (maxDate && isBefore(maxDate, _date, 'day')) {
    return maxDate;
  }
  return _date;
}
function isDisplayOneMonth(viewDate, minDate, maxDate) {
  if (maxDate && isSame(maxDate, viewDate, 'day')) {
    return true;
  }
  return minDate && maxDate && minDate.getMonth() === maxDate.getMonth();
}
let BsDatepickerStore = /*#__PURE__*/(() => {
  class BsDatepickerStore extends MiniStore {
    constructor() {
      const _dispatcher = new BehaviorSubject({
        type: '[datepicker] dispatcher init'
      });
      const state = new MiniState(initialDatepickerState, _dispatcher, bsDatepickerReducer);
      super(_dispatcher, bsDatepickerReducer, state);
    }
    static {
      this.ɵfac = function BsDatepickerStore_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsDatepickerStore)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BsDatepickerStore,
        factory: BsDatepickerStore.ɵfac,
        providedIn: 'platform'
      });
    }
  }
  return BsDatepickerStore;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsCustomDatesViewComponent = /*#__PURE__*/(() => {
  class BsCustomDatesViewComponent {
    constructor() {
      this.onSelect = new EventEmitter();
    }
    selectFromRanges(range) {
      this.onSelect.emit(range);
    }
    compareRanges(range) {
      return JSON.stringify(range?.value) === JSON.stringify(this.selectedRange);
    }
    static {
      this.ɵfac = function BsCustomDatesViewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsCustomDatesViewComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BsCustomDatesViewComponent,
        selectors: [["bs-custom-date-view"]],
        inputs: {
          ranges: "ranges",
          selectedRange: "selectedRange",
          customRangeLabel: "customRangeLabel"
        },
        outputs: {
          onSelect: "onSelect"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 1,
        consts: [[1, "bs-datepicker-predefined-btns"], ["type", "button", "class", "btn", 3, "selected", "click", 4, "ngFor", "ngForOf"], ["type", "button", 1, "btn", 3, "click"]],
        template: function BsCustomDatesViewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, BsCustomDatesViewComponent_button_1_Template, 2, 3, "button", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.ranges);
          }
        },
        dependencies: [NgFor],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return BsCustomDatesViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** *************** */
// events
/** *************** */
var BsNavigationDirection = /*#__PURE__*/function (BsNavigationDirection) {
  BsNavigationDirection[BsNavigationDirection["UP"] = 0] = "UP";
  BsNavigationDirection[BsNavigationDirection["DOWN"] = 1] = "DOWN";
  return BsNavigationDirection;
}(BsNavigationDirection || {});
let BsDatepickerNavigationViewComponent = /*#__PURE__*/(() => {
  class BsDatepickerNavigationViewComponent {
    constructor() {
      this.isDisabled = false;
      this.onNavigate = new EventEmitter();
      this.onViewMode = new EventEmitter();
    }
    navTo(down) {
      this.onNavigate.emit(down ? BsNavigationDirection.DOWN : BsNavigationDirection.UP);
    }
    view(viewMode) {
      if (this.isDisabled) {
        return;
      }
      this.onViewMode.emit(viewMode);
    }
    static {
      this.ɵfac = function BsDatepickerNavigationViewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsDatepickerNavigationViewComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BsDatepickerNavigationViewComponent,
        selectors: [["bs-datepicker-navigation-view"]],
        inputs: {
          calendar: "calendar",
          isDisabled: "isDisabled"
        },
        outputs: {
          onNavigate: "onNavigate",
          onViewMode: "onViewMode"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 12,
        vars: 9,
        consts: [["type", "button", 1, "previous", 3, "click", "disabled"], [4, "ngIf"], ["type", "button", 1, "current", 3, "click", "disabled"], ["type", "button", 1, "next", 3, "click", "disabled"]],
        template: function BsDatepickerNavigationViewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function BsDatepickerNavigationViewComponent_Template_button_click_0_listener() {
              return ctx.navTo(true);
            });
            i0.ɵɵelementStart(1, "span");
            i0.ɵɵtext(2, "\u2039");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(3, BsDatepickerNavigationViewComponent_ng_container_3_Template, 5, 2, "ng-container", 1);
            i0.ɵɵtext(4, " \u200B ");
            i0.ɵɵelementStart(5, "button", 2);
            i0.ɵɵlistener("click", function BsDatepickerNavigationViewComponent_Template_button_click_5_listener() {
              return ctx.view("year");
            });
            i0.ɵɵelementStart(6, "span");
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()();
            i0.ɵɵtext(8, " \u200B ");
            i0.ɵɵelementStart(9, "button", 3);
            i0.ɵɵlistener("click", function BsDatepickerNavigationViewComponent_Template_button_click_9_listener() {
              return ctx.navTo(false);
            });
            i0.ɵɵelementStart(10, "span");
            i0.ɵɵtext(11, "\u203A");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("visibility", ctx.calendar.hideLeftArrow ? "hidden" : "visible");
            i0.ɵɵproperty("disabled", ctx.calendar.disableLeftArrow);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.calendar && ctx.calendar.monthTitle);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.isDisabled);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.calendar.yearTitle);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("visibility", ctx.calendar.hideRightArrow ? "hidden" : "visible");
            i0.ɵɵproperty("disabled", ctx.calendar.disableRightArrow);
          }
        },
        dependencies: [NgIf],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return BsDatepickerNavigationViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsTimepickerViewComponent = /*#__PURE__*/(() => {
  class BsTimepickerViewComponent {
    constructor() {
      this.ampm = 'ok';
      this.hours = 0;
      this.minutes = 0;
    }
    static {
      this.ɵfac = function BsTimepickerViewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsTimepickerViewComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BsTimepickerViewComponent,
        selectors: [["bs-timepicker"]],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 16,
        vars: 3,
        consts: [[1, "bs-timepicker-container"], [1, "bs-timepicker-controls"], ["type", "button", 1, "bs-decrease"], ["type", "text", "placeholder", "00", 3, "value"], ["type", "button", 1, "bs-increase"], ["type", "button", 1, "switch-time-format"], ["src", "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAABSElEQVQYV3XQPUvDUBQG4HNuagtVqc6KgouCv6GIuIntYBLB9hcIQpLStCAIV7DYmpTcRWcXqZio3Vwc/UCc/QEqfgyKGbr0I7nS1EiHeqYzPO/h5SD0jaxUZjmSLCB+OFb+UFINFwASAEAdpu9gaGXVyAHHFQBkHpKHc6a9dzECvADyY9sqlAMsK9W0jzxDXqeytr3mhQckxSji27TJJ5/rPmIpwJJq3HrtduriYOurv1a4i1p5HnhkG9OFymi0ReoO05cGwb+ayv4dysVygjeFmsP05f8wpZQ8fsdvfmuY9zjWSNqUtgYFVnOVReILYoBFzdQI5/GGFzNHhGbeZnopDGU29sZbscgldmC99w35VOATTycIMMcBXIfpSVGzZhA6C8hh00conln6VQ9TGgV32OEAKQC4DrBq7CJwd0ggR7Vq/rPrfgB+C3sGypY5DAAAAABJRU5ErkJggg==", "alt", ""]],
        template: function BsTimepickerViewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "button", 2);
            i0.ɵɵtext(3, "-");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(4, "input", 3);
            i0.ɵɵelementStart(5, "button", 4);
            i0.ɵɵtext(6, "+");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "div", 1)(8, "button", 2);
            i0.ɵɵtext(9, "-");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(10, "input", 3);
            i0.ɵɵelementStart(11, "button", 4);
            i0.ɵɵtext(12, "+");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "button", 5);
            i0.ɵɵtext(14);
            i0.ɵɵelement(15, "img", 6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("value", ctx.hours);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("value", ctx.minutes);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1("", ctx.ampm, " ");
          }
        },
        encapsulation: 2
      });
    }
  }
  return BsTimepickerViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsCurrentDateViewComponent = /*#__PURE__*/(() => {
  class BsCurrentDateViewComponent {
    static {
      this.ɵfac = function BsCurrentDateViewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsCurrentDateViewComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BsCurrentDateViewComponent,
        selectors: [["bs-current-date"]],
        inputs: {
          title: "title"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 1,
        consts: [[1, "current-timedate"]],
        template: function BsCurrentDateViewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "span");
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.title);
          }
        },
        encapsulation: 2
      });
    }
  }
  return BsCurrentDateViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsCalendarLayoutComponent = /*#__PURE__*/(() => {
  class BsCalendarLayoutComponent {
    static {
      this.ɵfac = function BsCalendarLayoutComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsCalendarLayoutComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BsCalendarLayoutComponent,
        selectors: [["bs-calendar-layout"]],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 6,
        vars: 2,
        consts: [["title", "hey there", 4, "ngIf"], [1, "bs-datepicker-head"], [1, "bs-datepicker-body"], [4, "ngIf"], ["title", "hey there"]],
        template: function BsCalendarLayoutComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵtemplate(0, BsCalendarLayoutComponent_bs_current_date_0_Template, 1, 0, "bs-current-date", 0);
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵprojection(4, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, BsCalendarLayoutComponent_bs_timepicker_5_Template, 1, 0, "bs-timepicker", 3);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", false);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", false);
          }
        },
        dependencies: [NgIf, BsCurrentDateViewComponent, BsTimepickerViewComponent],
        encapsulation: 2
      });
    }
  }
  return BsCalendarLayoutComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsYearsCalendarViewComponent = /*#__PURE__*/(() => {
  class BsYearsCalendarViewComponent {
    constructor() {
      this.onNavigate = new EventEmitter();
      this.onViewMode = new EventEmitter();
      this.onSelect = new EventEmitter();
      this.onHover = new EventEmitter();
    }
    navigateTo(event) {
      const step = BsNavigationDirection.DOWN === event ? -1 : 1;
      this.onNavigate.emit({
        step: {
          year: step * yearsPerCalendar
        }
      });
    }
    viewYear(year) {
      this.onSelect.emit(year);
    }
    hoverYear(cell, isHovered) {
      this.onHover.emit({
        cell,
        isHovered
      });
    }
    changeViewMode(event) {
      this.onViewMode.emit(event);
    }
    static {
      this.ɵfac = function BsYearsCalendarViewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsYearsCalendarViewComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BsYearsCalendarViewComponent,
        selectors: [["bs-years-calendar-view"]],
        inputs: {
          calendar: "calendar"
        },
        outputs: {
          onNavigate: "onNavigate",
          onViewMode: "onViewMode",
          onSelect: "onSelect",
          onHover: "onHover"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 5,
        vars: 2,
        consts: [[3, "onNavigate", "onViewMode", "calendar"], ["role", "grid", 1, "years"], [4, "ngFor", "ngForOf"], ["role", "gridcell", 3, "disabled", "is-highlighted", "click", "mouseenter", "mouseleave", 4, "ngFor", "ngForOf"], ["role", "gridcell", 3, "click", "mouseenter", "mouseleave"]],
        template: function BsYearsCalendarViewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "bs-calendar-layout")(1, "bs-datepicker-navigation-view", 0);
            i0.ɵɵlistener("onNavigate", function BsYearsCalendarViewComponent_Template_bs_datepicker_navigation_view_onNavigate_1_listener($event) {
              return ctx.navigateTo($event);
            })("onViewMode", function BsYearsCalendarViewComponent_Template_bs_datepicker_navigation_view_onViewMode_1_listener($event) {
              return ctx.changeViewMode($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "table", 1)(3, "tbody");
            i0.ɵɵtemplate(4, BsYearsCalendarViewComponent_tr_4_Template, 2, 1, "tr", 2);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("calendar", ctx.calendar);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.calendar == null ? null : ctx.calendar.years);
          }
        },
        dependencies: [BsCalendarLayoutComponent, BsDatepickerNavigationViewComponent, NgFor],
        encapsulation: 2
      });
    }
  }
  return BsYearsCalendarViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsMonthCalendarViewComponent = /*#__PURE__*/(() => {
  class BsMonthCalendarViewComponent {
    constructor() {
      this.onNavigate = new EventEmitter();
      this.onViewMode = new EventEmitter();
      this.onSelect = new EventEmitter();
      this.onHover = new EventEmitter();
    }
    navigateTo(event) {
      const step = BsNavigationDirection.DOWN === event ? -1 : 1;
      this.onNavigate.emit({
        step: {
          year: step
        }
      });
    }
    viewMonth(month) {
      this.onSelect.emit(month);
    }
    hoverMonth(cell, isHovered) {
      this.onHover.emit({
        cell,
        isHovered
      });
    }
    changeViewMode(event) {
      this.onViewMode.emit(event);
    }
    static {
      this.ɵfac = function BsMonthCalendarViewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsMonthCalendarViewComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BsMonthCalendarViewComponent,
        selectors: [["bs-month-calendar-view"]],
        inputs: {
          calendar: "calendar"
        },
        outputs: {
          onNavigate: "onNavigate",
          onViewMode: "onViewMode",
          onSelect: "onSelect",
          onHover: "onHover"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 5,
        vars: 2,
        consts: [[3, "onNavigate", "onViewMode", "calendar"], ["role", "grid", 1, "months"], [4, "ngFor", "ngForOf"], ["role", "gridcell", 3, "disabled", "is-highlighted", "click", "mouseenter", "mouseleave", 4, "ngFor", "ngForOf"], ["role", "gridcell", 3, "click", "mouseenter", "mouseleave"]],
        template: function BsMonthCalendarViewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "bs-calendar-layout")(1, "bs-datepicker-navigation-view", 0);
            i0.ɵɵlistener("onNavigate", function BsMonthCalendarViewComponent_Template_bs_datepicker_navigation_view_onNavigate_1_listener($event) {
              return ctx.navigateTo($event);
            })("onViewMode", function BsMonthCalendarViewComponent_Template_bs_datepicker_navigation_view_onViewMode_1_listener($event) {
              return ctx.changeViewMode($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "table", 1)(3, "tbody");
            i0.ɵɵtemplate(4, BsMonthCalendarViewComponent_tr_4_Template, 2, 1, "tr", 2);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("calendar", ctx.calendar);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.calendar == null ? null : ctx.calendar.months);
          }
        },
        dependencies: [BsCalendarLayoutComponent, BsDatepickerNavigationViewComponent, NgFor],
        encapsulation: 2
      });
    }
  }
  return BsMonthCalendarViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsDatepickerDayDecoratorComponent = /*#__PURE__*/(() => {
  class BsDatepickerDayDecoratorComponent {
    constructor(_config, _elRef, _renderer) {
      this._config = _config;
      this._elRef = _elRef;
      this._renderer = _renderer;
      this.day = {
        date: new Date(),
        label: ''
      };
    }
    ngOnInit() {
      if (this.day?.isToday && this._config && this._config.customTodayClass) {
        this._renderer.addClass(this._elRef.nativeElement, this._config.customTodayClass);
      }
      if (typeof this.day?.customClasses === 'string') {
        this.day?.customClasses.split(' ').filter(className => className).forEach(className => {
          this._renderer.addClass(this._elRef.nativeElement, className);
        });
      }
    }
    static {
      this.ɵfac = function BsDatepickerDayDecoratorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsDatepickerDayDecoratorComponent)(i0.ɵɵdirectiveInject(BsDatepickerConfig), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BsDatepickerDayDecoratorComponent,
        selectors: [["", "bsDatepickerDayDecorator", ""]],
        hostVars: 16,
        hostBindings: function BsDatepickerDayDecoratorComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("disabled", ctx.day.isDisabled)("is-highlighted", ctx.day.isHovered)("is-other-month", ctx.day.isOtherMonth)("is-active-other-month", ctx.day.isOtherMonthHovered)("in-range", ctx.day.isInRange)("select-start", ctx.day.isSelectionStart)("select-end", ctx.day.isSelectionEnd)("selected", ctx.day.isSelected);
          }
        },
        inputs: {
          day: "day"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        attrs: _c2,
        decls: 1,
        vars: 1,
        template: function BsDatepickerDayDecoratorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtext(0);
          }
          if (rf & 2) {
            i0.ɵɵtextInterpolate(ctx.day && ctx.day.label || "");
          }
        },
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return BsDatepickerDayDecoratorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsDaysCalendarViewComponent = /*#__PURE__*/(() => {
  class BsDaysCalendarViewComponent {
    constructor(_config) {
      this._config = _config;
      this.onNavigate = new EventEmitter();
      this.onViewMode = new EventEmitter();
      this.onSelect = new EventEmitter();
      this.onHover = new EventEmitter();
      this.onHoverWeek = new EventEmitter();
      this.isiOS = /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
      if (this._config.dateTooltipTexts && this._config.dateTooltipTexts.length > 0) {
        this.isShowTooltip = true;
      }
    }
    navigateTo(event) {
      const step = BsNavigationDirection.DOWN === event ? -1 : 1;
      this.onNavigate.emit({
        step: {
          month: step
        }
      });
    }
    changeViewMode(event) {
      this.onViewMode.emit(event);
    }
    selectDay(event) {
      this.onSelect.emit(event);
    }
    selectWeek(week) {
      if (!this._config.selectWeek && !this._config.selectWeekDateRange) {
        return;
      }
      if (week.days.length === 0) {
        return;
      }
      if (this._config.selectWeek && week.days[0] && !week.days[0].isDisabled && this._config.selectFromOtherMonth) {
        this.onSelect.emit(week.days[0]);
        return;
      }
      const selectedDay = week.days.find(day => {
        return this._config.selectFromOtherMonth ? !day.isDisabled : !day.isOtherMonth && !day.isDisabled;
      });
      this.onSelect.emit(selectedDay);
      if (this._config.selectWeekDateRange) {
        const days = week.days.slice(0);
        const lastDayOfRange = days.reverse().find(day => {
          return this._config.selectFromOtherMonth ? !day.isDisabled : !day.isOtherMonth && !day.isDisabled;
        });
        this.onSelect.emit(lastDayOfRange);
      }
    }
    weekHoverHandler(cell, isHovered) {
      if (!this._config.selectWeek && !this._config.selectWeekDateRange) {
        return;
      }
      const hasActiveDays = cell.days.find(day => {
        return this._config.selectFromOtherMonth ? !day.isDisabled : !day.isOtherMonth && !day.isDisabled;
      });
      if (hasActiveDays) {
        cell.isHovered = isHovered;
        this.isWeekHovered = isHovered;
        this.onHoverWeek.emit(cell);
      }
    }
    hoverDay(cell, isHovered) {
      if (this._config.selectFromOtherMonth && cell.isOtherMonth) {
        cell.isOtherMonthHovered = isHovered;
      }
      if (this._config.dateTooltipTexts) {
        cell.tooltipText = '';
        this._config.dateTooltipTexts.forEach(dateData => {
          if (isSameDay(dateData.date, cell.date)) {
            cell.tooltipText = dateData.tooltipText;
            return;
          }
        });
      }
      this.onHover.emit({
        cell,
        isHovered
      });
    }
    static {
      this.ɵfac = function BsDaysCalendarViewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsDaysCalendarViewComponent)(i0.ɵɵdirectiveInject(BsDatepickerConfig));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BsDaysCalendarViewComponent,
        selectors: [["bs-days-calendar-view"]],
        inputs: {
          calendar: "calendar",
          options: "options",
          isDisabled: "isDisabled"
        },
        outputs: {
          onNavigate: "onNavigate",
          onViewMode: "onViewMode",
          onSelect: "onSelect",
          onHover: "onHover",
          onHoverWeek: "onHoverWeek"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 9,
        vars: 5,
        consts: [[3, "onNavigate", "onViewMode", "calendar", "isDisabled"], ["role", "grid", 1, "days", "weeks"], [4, "ngIf"], ["aria-label", "weekday", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], ["aria-label", "weekday"], ["class", "week", 3, "active-week", 4, "ngIf"], ["role", "gridcell", 4, "ngFor", "ngForOf"], [1, "week"], [3, "click", 4, "ngIf"], [3, "click", "mouseenter", "mouseleave", 4, "ngIf"], [3, "click"], [3, "click", "mouseenter", "mouseleave"], ["role", "gridcell"], ["bsDatepickerDayDecorator", "", 3, "day", "tooltip", "click", "mouseenter", "mouseleave", 4, "ngIf"], ["bsDatepickerDayDecorator", "", 3, "day", "click", "mouseenter", "mouseleave", 4, "ngIf"], ["bsDatepickerDayDecorator", "", 3, "day", "click", 4, "ngIf"], ["bsDatepickerDayDecorator", "", 3, "click", "mouseenter", "mouseleave", "day", "tooltip"], ["bsDatepickerDayDecorator", "", 3, "click", "mouseenter", "mouseleave", "day"], ["bsDatepickerDayDecorator", "", 3, "click", "day"]],
        template: function BsDaysCalendarViewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "bs-calendar-layout")(1, "bs-datepicker-navigation-view", 0);
            i0.ɵɵlistener("onNavigate", function BsDaysCalendarViewComponent_Template_bs_datepicker_navigation_view_onNavigate_1_listener($event) {
              return ctx.navigateTo($event);
            })("onViewMode", function BsDaysCalendarViewComponent_Template_bs_datepicker_navigation_view_onViewMode_1_listener($event) {
              return ctx.changeViewMode($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "table", 1)(3, "thead")(4, "tr");
            i0.ɵɵtemplate(5, BsDaysCalendarViewComponent_th_5_Template, 1, 0, "th", 2)(6, BsDaysCalendarViewComponent_th_6_Template, 2, 1, "th", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "tbody");
            i0.ɵɵtemplate(8, BsDaysCalendarViewComponent_tr_8_Template, 3, 2, "tr", 4);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("calendar", ctx.calendar)("isDisabled", !!ctx.isDisabled);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.options && ctx.options.showWeekNumbers);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.calendar.weekdays);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.calendar.weeks);
          }
        },
        dependencies: [BsCalendarLayoutComponent, BsDatepickerNavigationViewComponent, NgIf, NgFor, BsDatepickerDayDecoratorComponent, TooltipModule, i2.TooltipDirective],
        encapsulation: 2
      });
    }
  }
  return BsDaysCalendarViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsDatepickerContainerComponent = /*#__PURE__*/(() => {
  class BsDatepickerContainerComponent extends BsDatepickerAbstractComponent {
    set value(value) {
      this._effects?.setValue(value);
    }
    get isDatePickerDisabled() {
      return !!this._config.isDisabled;
    }
    get isDatepickerDisabled() {
      return this.isDatePickerDisabled ? '' : null;
    }
    get isDatepickerReadonly() {
      return this.isDatePickerDisabled ? '' : null;
    }
    constructor(_renderer, _config, _store, _element, _actions, _effects, _positionService) {
      super();
      this._config = _config;
      this._store = _store;
      this._element = _element;
      this._actions = _actions;
      this._positionService = _positionService;
      this.valueChange = new EventEmitter();
      this.animationState = 'void';
      this.isRangePicker = false;
      this._subs = [];
      this._effects = _effects;
      _renderer.setStyle(_element.nativeElement, 'display', 'block');
      _renderer.setStyle(_element.nativeElement, 'position', 'absolute');
    }
    ngOnInit() {
      this._positionService.setOptions({
        modifiers: {
          flip: {
            enabled: this._config.adaptivePosition
          },
          preventOverflow: {
            enabled: this._config.adaptivePosition
          }
        },
        allowedPositions: this._config.allowedPositions
      });
      this._positionService.event$?.pipe(take(1)).subscribe(() => {
        this._positionService.disable();
        if (this._config.isAnimated) {
          this.animationState = this.isTopPosition ? 'animated-up' : 'animated-down';
          return;
        }
        this.animationState = 'unanimated';
      });
      this.isOtherMonthsActive = this._config.selectFromOtherMonth;
      this.containerClass = this._config.containerClass;
      this.showTodayBtn = this._config.showTodayButton;
      this.todayBtnLbl = this._config.todayButtonLabel;
      this.todayPos = this._config.todayPosition;
      this.showClearBtn = this._config.showClearButton;
      this.clearBtnLbl = this._config.clearButtonLabel;
      this.clearPos = this._config.clearPosition;
      this.customRangeBtnLbl = this._config.customRangeButtonLabel;
      this.withTimepicker = this._config.withTimepicker;
      this._effects?.init(this._store)
      // intial state options
      .setOptions(this._config)
      // data binding view --> model
      .setBindings(this)
      // set event handlers
      .setEventHandlers(this).registerDatepickerSideEffects();
      let currentDate;
      // todo: move it somewhere else
      // on selected date change
      this._subs.push(this._store.select(state => state.selectedDate).subscribe(date => {
        currentDate = date;
        this.valueChange.emit(date);
      }));
      this._subs.push(this._store.select(state => state.selectedTime).subscribe(time => {
        if (!time || !time[0] || !(time[0] instanceof Date) || time[0] === currentDate) {
          return;
        }
        this.valueChange.emit(time[0]);
      }));
      this._store.dispatch(this._actions.changeViewMode(this._config.startView));
    }
    ngAfterViewInit() {
      this.selectedTimeSub.add(this.selectedTime?.subscribe(val => {
        if (Array.isArray(val) && val.length >= 1) {
          this.startTimepicker?.writeValue(val[0]);
        }
      }));
      this.startTimepicker?.registerOnChange(val => {
        this.timeSelectHandler(val, 0);
      });
    }
    get isTopPosition() {
      return this._element.nativeElement.classList.contains('top');
    }
    positionServiceEnable() {
      this._positionService.enable();
    }
    timeSelectHandler(date, index) {
      this._store.dispatch(this._actions.selectTime(date, index));
    }
    daySelectHandler(day) {
      if (!day) {
        return;
      }
      const isDisabled = this.isOtherMonthsActive ? day.isDisabled : day.isOtherMonth || day.isDisabled;
      if (isDisabled) {
        return;
      }
      this._store.dispatch(this._actions.select(day.date));
    }
    monthSelectHandler(day) {
      if (!day || day.isDisabled) {
        return;
      }
      this._store.dispatch(this._actions.navigateTo({
        unit: {
          month: getMonth(day.date),
          year: getFullYear(day.date)
        },
        viewMode: 'day'
      }));
    }
    yearSelectHandler(day) {
      if (!day || day.isDisabled) {
        return;
      }
      this._store.dispatch(this._actions.navigateTo({
        unit: {
          year: getFullYear(day.date)
        },
        viewMode: 'month'
      }));
    }
    setToday() {
      this._store.dispatch(this._actions.select(new Date()));
    }
    clearDate() {
      this._store.dispatch(this._actions.select(undefined));
    }
    ngOnDestroy() {
      for (const sub of this._subs) {
        sub.unsubscribe();
      }
      this.selectedTimeSub.unsubscribe();
      this._effects?.destroy();
    }
    static {
      this.ɵfac = function BsDatepickerContainerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsDatepickerContainerComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(BsDatepickerConfig), i0.ɵɵdirectiveInject(BsDatepickerStore), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(BsDatepickerActions), i0.ɵɵdirectiveInject(BsDatepickerEffects), i0.ɵɵdirectiveInject(i5.PositioningService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BsDatepickerContainerComponent,
        selectors: [["bs-datepicker-container"]],
        viewQuery: function BsDatepickerContainerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c3, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.startTimepicker = _t.first);
          }
        },
        hostAttrs: ["role", "dialog", "aria-label", "calendar", 1, "bottom"],
        hostVars: 2,
        hostBindings: function BsDatepickerContainerComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function BsDatepickerContainerComponent_click_HostBindingHandler($event) {
              return ctx._stopPropagation($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("disabled", ctx.isDatepickerDisabled)("readonly", ctx.isDatepickerReadonly);
          }
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([BsDatepickerStore, BsDatepickerEffects, BsDatepickerActions, PositioningService]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 3,
        consts: [["startTP", ""], ["endTP", ""], ["class", "bs-datepicker", 3, "ngClass", 4, "ngIf"], [1, "bs-datepicker", 3, "ngClass"], [1, "bs-datepicker-container"], ["role", "application", 1, "bs-calendar-container", 3, "ngSwitch"], [4, "ngSwitchCase"], ["class", "bs-media-container", 4, "ngSwitchCase"], ["class", "bs-datepicker-buttons", 4, "ngIf"], ["class", "bs-datepicker-custom-range", 4, "ngIf"], [1, "bs-media-container"], [3, "bs-datepicker-multiple", "calendar", "isDisabled", "options", "onNavigate", "onViewMode", "onHover", "onHoverWeek", "onSelect", 4, "ngFor", "ngForOf"], ["class", "bs-timepicker-in-datepicker-container", 4, "ngIf"], [3, "onNavigate", "onViewMode", "onHover", "onHoverWeek", "onSelect", "calendar", "isDisabled", "options"], [1, "bs-timepicker-in-datepicker-container"], [3, "disabled"], [3, "disabled", 4, "ngIf"], [3, "bs-datepicker-multiple", "calendar", "onNavigate", "onViewMode", "onHover", "onSelect", 4, "ngFor", "ngForOf"], [3, "onNavigate", "onViewMode", "onHover", "onSelect", "calendar"], [1, "bs-datepicker-buttons"], ["type", "button", 1, "btn", "btn-success"], ["type", "button", 1, "btn", "btn-default"], ["class", "btn-today-wrapper", 3, "today-left", "today-right", "today-center", 4, "ngIf"], ["class", "btn-clear-wrapper", 3, "clear-left", "clear-right", "clear-center", 4, "ngIf"], [1, "btn-today-wrapper"], [1, "btn", "btn-success", 3, "click"], [1, "btn-clear-wrapper"], [1, "bs-datepicker-custom-range"], [3, "onSelect", "selectedRange", "ranges", "customRangeLabel"]],
        template: function BsDatepickerContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, BsDatepickerContainerComponent_div_0_Template, 10, 11, "div", 2);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.viewMode));
          }
        },
        dependencies: [NgIf, NgClass, NgSwitch, NgSwitchCase, NgFor, BsDaysCalendarViewComponent, TimepickerModule, i6.TimepickerComponent, BsMonthCalendarViewComponent, BsYearsCalendarViewComponent, BsCustomDatesViewComponent, AsyncPipe],
        encapsulation: 2,
        data: {
          animation: [datepickerAnimation]
        }
      });
    }
  }
  return BsDatepickerContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let previousDate$1;
let BsDatepickerDirective = /*#__PURE__*/(() => {
  class BsDatepickerDirective {
    get readonlyValue() {
      return this.isDisabled ? '' : null;
    }
    constructor(_config, _elementRef, _renderer, _viewContainerRef, cis) {
      this._config = _config;
      this._elementRef = _elementRef;
      this._renderer = _renderer;
      /**
       * Placement of a datepicker. Accepts: "top", "bottom", "left", "right"
       */
      this.placement = 'bottom';
      /**
       * Specifies events that should trigger. Supports a space separated list of
       * event names.
       */
      this.triggers = 'click';
      /**
       * Close datepicker on outside click
       */
      this.outsideClick = true;
      /**
       * A selector specifying the element the datepicker should be appended to.
       */
      this.container = 'body';
      this.outsideEsc = true;
      this.isDestroy$ = new Subject();
      /**
       * Indicates whether datepicker's content is enabled or not
       */
      this.isDisabled = false;
      /**
       * Emits when datepicker value has been changed
       */
      this.bsValueChange = new EventEmitter();
      this._subs = [];
      this._dateInputFormat$ = new Subject();
      // todo: assign only subset of fields
      Object.assign(this, this._config);
      this._datepicker = cis.createLoader(_elementRef, _viewContainerRef, _renderer);
      this.onShown = this._datepicker.onShown;
      this.onHidden = this._datepicker.onHidden;
      this.isOpen$ = new BehaviorSubject(this.isOpen);
    }
    /**
     * Returns whether or not the datepicker is currently being shown
     */
    get isOpen() {
      return this._datepicker.isShown;
    }
    set isOpen(value) {
      this.isOpen$.next(value);
    }
    /**
     * Initial value of datepicker
     */
    set bsValue(value) {
      if (this._bsValue && value && this._bsValue.getTime() === value.getTime()) {
        return;
      }
      if (!this._bsValue && value && !this._config.withTimepicker) {
        const now = new Date();
        copyTime(value, now);
      }
      if (value && this.bsConfig?.initCurrentTime) {
        value = setCurrentTimeOnDateSelect(value);
      }
      this.initPreviousValue();
      this._bsValue = value;
      this.bsValueChange.emit(value);
    }
    get dateInputFormat$() {
      return this._dateInputFormat$;
    }
    ngOnInit() {
      this._datepicker.listen({
        outsideClick: this.outsideClick,
        outsideEsc: this.outsideEsc,
        triggers: this.triggers,
        show: () => this.show()
      });
      this.setConfig();
      this.initPreviousValue();
    }
    initPreviousValue() {
      previousDate$1 = this._bsValue;
    }
    ngOnChanges(changes) {
      if (changes["bsConfig"]) {
        if (changes["bsConfig"].currentValue?.initCurrentTime && changes["bsConfig"].currentValue?.initCurrentTime !== changes["bsConfig"].previousValue?.initCurrentTime && this._bsValue) {
          this.initPreviousValue();
          this._bsValue = setCurrentTimeOnDateSelect(this._bsValue);
          this.bsValueChange.emit(this._bsValue);
        }
        this.setConfig();
        this._dateInputFormat$.next(this.bsConfig && this.bsConfig.dateInputFormat);
      }
      if (!this._datepickerRef || !this._datepickerRef.instance) {
        return;
      }
      if (changes["minDate"]) {
        this._datepickerRef.instance.minDate = this.minDate;
      }
      if (changes["maxDate"]) {
        this._datepickerRef.instance.maxDate = this.maxDate;
      }
      if (changes["daysDisabled"]) {
        this._datepickerRef.instance.daysDisabled = this.daysDisabled;
      }
      if (changes["datesDisabled"]) {
        this._datepickerRef.instance.datesDisabled = this.datesDisabled;
      }
      if (changes["datesEnabled"]) {
        this._datepickerRef.instance.datesEnabled = this.datesEnabled;
      }
      if (changes["isDisabled"]) {
        this._datepickerRef.instance.isDisabled = this.isDisabled;
      }
      if (changes["dateCustomClasses"]) {
        this._datepickerRef.instance.dateCustomClasses = this.dateCustomClasses;
      }
      if (changes["dateTooltipTexts"]) {
        this._datepickerRef.instance.dateTooltipTexts = this.dateTooltipTexts;
      }
    }
    initSubscribes() {
      // if date changes from external source (model -> view)
      this._subs.push(this.bsValueChange.subscribe(value => {
        if (this._datepickerRef) {
          this._datepickerRef.instance.value = value;
        }
      }));
      // if date changes from picker (view -> model)
      if (this._datepickerRef) {
        this._subs.push(this._datepickerRef.instance.valueChange.subscribe(value => {
          this.initPreviousValue();
          this.bsValue = value;
          if (this.keepDatepickerModalOpened()) {
            return;
          }
          this.hide();
        }));
      }
    }
    keepDatepickerModalOpened() {
      if (!previousDate$1 || !this.bsConfig?.keepDatepickerOpened || !this._config.withTimepicker) {
        return false;
      }
      return this.isDateSame();
    }
    isDateSame() {
      return previousDate$1 instanceof Date && this._bsValue?.getDate() === previousDate$1?.getDate() && this._bsValue?.getMonth() === previousDate$1?.getMonth() && this._bsValue?.getFullYear() === previousDate$1?.getFullYear();
    }
    ngAfterViewInit() {
      this.isOpen$.pipe(filter(isOpen => isOpen !== this.isOpen), takeUntil(this.isDestroy$)).subscribe(() => this.toggle());
    }
    /**
     * Opens an element’s datepicker. This is considered a “manual” triggering of
     * the datepicker.
     */
    show() {
      if (this._datepicker.isShown) {
        return;
      }
      this.setConfig();
      this._datepickerRef = this._datepicker.provide({
        provide: BsDatepickerConfig,
        useValue: this._config
      }).attach(BsDatepickerContainerComponent).to(this.container).position({
        attachment: this.placement
      }).show({
        placement: this.placement
      });
      this.initSubscribes();
    }
    /**
     * Closes an element’s datepicker. This is considered a “manual” triggering of
     * the datepicker.
     */
    hide() {
      if (this.isOpen) {
        this._datepicker.hide();
      }
      for (const sub of this._subs) {
        sub.unsubscribe();
      }
      if (this._config.returnFocusToInput) {
        this._renderer.selectRootElement(this._elementRef.nativeElement).focus();
      }
    }
    /**
     * Toggles an element’s datepicker. This is considered a “manual” triggering
     * of the datepicker.
     */
    toggle() {
      if (this.isOpen) {
        return this.hide();
      }
      this.show();
    }
    /**
     * Set config for datepicker
     */
    setConfig() {
      this._config = Object.assign({}, this._config, this.bsConfig, {
        value: this._config.keepDatesOutOfRules ? this._bsValue : checkBsValue(this._bsValue, this.maxDate || this.bsConfig && this.bsConfig.maxDate),
        isDisabled: this.isDisabled,
        minDate: this.minDate || this.bsConfig && this.bsConfig.minDate,
        maxDate: this.maxDate || this.bsConfig && this.bsConfig.maxDate,
        daysDisabled: this.daysDisabled || this.bsConfig && this.bsConfig.daysDisabled,
        dateCustomClasses: this.dateCustomClasses || this.bsConfig && this.bsConfig.dateCustomClasses,
        dateTooltipTexts: this.dateTooltipTexts || this.bsConfig && this.bsConfig.dateTooltipTexts,
        datesDisabled: this.datesDisabled || this.bsConfig && this.bsConfig.datesDisabled,
        datesEnabled: this.datesEnabled || this.bsConfig && this.bsConfig.datesEnabled,
        minMode: this.minMode || this.bsConfig && this.bsConfig.minMode,
        initCurrentTime: this.bsConfig?.initCurrentTime,
        keepDatepickerOpened: this.bsConfig?.keepDatepickerOpened,
        keepDatesOutOfRules: this.bsConfig?.keepDatesOutOfRules
      });
    }
    unsubscribeSubscriptions() {
      if (this._subs?.length) {
        this._subs.map(sub => sub.unsubscribe());
        this._subs.length = 0;
      }
    }
    ngOnDestroy() {
      this._datepicker.dispose();
      this.isOpen$.next(false);
      if (this.isDestroy$) {
        this.isDestroy$.next(null);
        this.isDestroy$.complete();
      }
      this.unsubscribeSubscriptions();
    }
    static {
      this.ɵfac = function BsDatepickerDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsDatepickerDirective)(i0.ɵɵdirectiveInject(BsDatepickerConfig), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i2$1.ComponentLoaderFactory));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: BsDatepickerDirective,
        selectors: [["", "bsDatepicker", ""]],
        hostVars: 1,
        hostBindings: function BsDatepickerDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("readonly", ctx.readonlyValue);
          }
        },
        inputs: {
          placement: "placement",
          triggers: "triggers",
          outsideClick: "outsideClick",
          container: "container",
          outsideEsc: "outsideEsc",
          isDisabled: "isDisabled",
          minDate: "minDate",
          maxDate: "maxDate",
          ignoreMinMaxErrors: "ignoreMinMaxErrors",
          minMode: "minMode",
          daysDisabled: "daysDisabled",
          datesDisabled: "datesDisabled",
          datesEnabled: "datesEnabled",
          dateCustomClasses: "dateCustomClasses",
          dateTooltipTexts: "dateTooltipTexts",
          isOpen: "isOpen",
          bsValue: "bsValue",
          bsConfig: "bsConfig"
        },
        outputs: {
          onShown: "onShown",
          onHidden: "onHidden",
          bsValueChange: "bsValueChange"
        },
        exportAs: ["bsDatepicker"],
        standalone: true,
        features: [i0.ɵɵProvidersFeature([ComponentLoaderFactory]), i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return BsDatepickerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsDatepickerInlineConfig = /*#__PURE__*/(() => {
  class BsDatepickerInlineConfig extends BsDatepickerConfig {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵBsDatepickerInlineConfig_BaseFactory;
        return function BsDatepickerInlineConfig_Factory(__ngFactoryType__) {
          return (ɵBsDatepickerInlineConfig_BaseFactory || (ɵBsDatepickerInlineConfig_BaseFactory = i0.ɵɵgetInheritedFactory(BsDatepickerInlineConfig)))(__ngFactoryType__ || BsDatepickerInlineConfig);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BsDatepickerInlineConfig,
        factory: BsDatepickerInlineConfig.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BsDatepickerInlineConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsDatepickerInlineContainerComponent = /*#__PURE__*/(() => {
  class BsDatepickerInlineContainerComponent extends BsDatepickerContainerComponent {
    get disabledValue() {
      return this.isDatePickerDisabled ? '' : null;
    }
    get readonlyValue() {
      return this.isDatePickerDisabled ? '' : null;
    }
    constructor(_renderer, _config, _store, _element, _actions, _effects, _positioningService) {
      super(_renderer, _config, _store, _element, _actions, _effects, _positioningService);
      _renderer.setStyle(_element.nativeElement, 'display', 'inline-block');
      _renderer.setStyle(_element.nativeElement, 'position', 'static');
    }
    static {
      this.ɵfac = function BsDatepickerInlineContainerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsDatepickerInlineContainerComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(BsDatepickerConfig), i0.ɵɵdirectiveInject(BsDatepickerStore), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(BsDatepickerActions), i0.ɵɵdirectiveInject(BsDatepickerEffects), i0.ɵɵdirectiveInject(i5.PositioningService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BsDatepickerInlineContainerComponent,
        selectors: [["bs-datepicker-inline-container"]],
        hostVars: 2,
        hostBindings: function BsDatepickerInlineContainerComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function BsDatepickerInlineContainerComponent_click_HostBindingHandler($event) {
              return ctx._stopPropagation($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("disabled", ctx.disabledValue)("readonly", ctx.readonlyValue);
          }
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([BsDatepickerStore, BsDatepickerEffects, PositioningService]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 3,
        consts: [["startTP", ""], ["endTP", ""], ["class", "bs-datepicker", 3, "ngClass", 4, "ngIf"], [1, "bs-datepicker", 3, "ngClass"], [1, "bs-datepicker-container"], ["role", "application", 1, "bs-calendar-container", 3, "ngSwitch"], [4, "ngSwitchCase"], ["class", "bs-media-container", 4, "ngSwitchCase"], ["class", "bs-datepicker-buttons", 4, "ngIf"], ["class", "bs-datepicker-custom-range", 4, "ngIf"], [1, "bs-media-container"], [3, "bs-datepicker-multiple", "calendar", "isDisabled", "options", "onNavigate", "onViewMode", "onHover", "onHoverWeek", "onSelect", 4, "ngFor", "ngForOf"], ["class", "bs-timepicker-in-datepicker-container", 4, "ngIf"], [3, "onNavigate", "onViewMode", "onHover", "onHoverWeek", "onSelect", "calendar", "isDisabled", "options"], [1, "bs-timepicker-in-datepicker-container"], [3, "disabled"], [3, "disabled", 4, "ngIf"], [3, "bs-datepicker-multiple", "calendar", "onNavigate", "onViewMode", "onHover", "onSelect", 4, "ngFor", "ngForOf"], [3, "onNavigate", "onViewMode", "onHover", "onSelect", "calendar"], [1, "bs-datepicker-buttons"], ["type", "button", 1, "btn", "btn-success"], ["type", "button", 1, "btn", "btn-default"], ["class", "btn-today-wrapper", 3, "today-left", "today-right", "today-center", 4, "ngIf"], ["class", "btn-clear-wrapper", 3, "clear-left", "clear-right", "clear-center", 4, "ngIf"], [1, "btn-today-wrapper"], [1, "btn", "btn-success", 3, "click"], [1, "btn-clear-wrapper"], [1, "bs-datepicker-custom-range"], [3, "onSelect", "selectedRange", "ranges", "customRangeLabel"]],
        template: function BsDatepickerInlineContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, BsDatepickerInlineContainerComponent_div_0_Template, 10, 11, "div", 2);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.viewMode));
          }
        },
        dependencies: [NgIf, NgClass, NgSwitch, NgSwitchCase, NgFor, BsDaysCalendarViewComponent, TimepickerModule, i6.TimepickerComponent, BsMonthCalendarViewComponent, BsYearsCalendarViewComponent, BsCustomDatesViewComponent, AsyncPipe],
        encapsulation: 2,
        data: {
          animation: [datepickerAnimation]
        }
      });
    }
  }
  return BsDatepickerInlineContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsDatepickerInlineDirective = /*#__PURE__*/(() => {
  class BsDatepickerInlineDirective {
    constructor(_config, _elementRef, _renderer, _viewContainerRef, cis) {
      this._config = _config;
      this._elementRef = _elementRef;
      /**
       * Indicates whether datepicker is enabled or not
       */
      this.isDisabled = false;
      /**
       * Emits when datepicker value has been changed
       */
      this.bsValueChange = new EventEmitter();
      this._subs = [];
      // todo: assign only subset of fields
      Object.assign(this, this._config);
      this._datepicker = cis.createLoader(_elementRef, _viewContainerRef, _renderer);
    }
    /**
     * Initial value of datepicker
     */
    set bsValue(value) {
      if (this._bsValue === value) {
        return;
      }
      if (!this._bsValue && value && !this._config.withTimepicker) {
        const now = new Date();
        copyTime(value, now);
      }
      if (value && this.bsConfig?.initCurrentTime) {
        value = setCurrentTimeOnDateSelect(value);
      }
      this._bsValue = value;
      this.bsValueChange.emit(value);
    }
    ngOnInit() {
      this.setConfig();
      this.initSubscribes();
    }
    initSubscribes() {
      this.unsubscribeSubscriptions();
      this._subs.push(this.bsValueChange.subscribe(value => {
        if (this._datepickerRef) {
          this._datepickerRef.instance.value = value;
        }
      }));
      if (this._datepickerRef) {
        this._subs.push(this._datepickerRef.instance.valueChange.subscribe(value => {
          this.bsValue = value;
        }));
      }
    }
    unsubscribeSubscriptions() {
      if (this._subs?.length) {
        this._subs.map(sub => sub.unsubscribe());
        this._subs.length = 0;
      }
    }
    ngOnChanges(changes) {
      if (changes["bsConfig"]) {
        if (changes["bsConfig"].currentValue?.initCurrentTime && changes["bsConfig"].currentValue?.initCurrentTime !== changes["bsConfig"].previousValue?.initCurrentTime && this._bsValue) {
          this._bsValue = setCurrentTimeOnDateSelect(this._bsValue);
          this.bsValueChange.emit(this._bsValue);
        }
      }
      if (!this._datepickerRef || !this._datepickerRef.instance) {
        return;
      }
      if (changes["minDate"]) {
        this._datepickerRef.instance.minDate = this.minDate;
      }
      if (changes["maxDate"]) {
        this._datepickerRef.instance.maxDate = this.maxDate;
      }
      if (changes["datesDisabled"]) {
        this._datepickerRef.instance.datesDisabled = this.datesDisabled;
      }
      if (changes["datesEnabled"]) {
        this._datepickerRef.instance.datesEnabled = this.datesEnabled;
        this._datepickerRef.instance.value = this._bsValue;
      }
      if (changes["isDisabled"]) {
        this._datepickerRef.instance.isDisabled = this.isDisabled;
      }
      if (changes["dateCustomClasses"]) {
        this._datepickerRef.instance.dateCustomClasses = this.dateCustomClasses;
      }
      if (changes["dateTooltipTexts"]) {
        this._datepickerRef.instance.dateTooltipTexts = this.dateTooltipTexts;
      }
      this.setConfig();
    }
    /**
     * Set config for datepicker
     */
    setConfig() {
      if (this._datepicker) {
        this._datepicker.hide();
      }
      this._config = Object.assign({}, this._config, this.bsConfig, {
        value: checkBsValue(this._bsValue, this.maxDate || this.bsConfig && this.bsConfig.maxDate),
        isDisabled: this.isDisabled,
        minDate: this.minDate || this.bsConfig && this.bsConfig.minDate,
        maxDate: this.maxDate || this.bsConfig && this.bsConfig.maxDate,
        dateCustomClasses: this.dateCustomClasses || this.bsConfig && this.bsConfig.dateCustomClasses,
        dateTooltipTexts: this.dateTooltipTexts || this.bsConfig && this.bsConfig.dateTooltipTexts,
        datesDisabled: this.datesDisabled || this.bsConfig && this.bsConfig.datesDisabled,
        datesEnabled: this.datesEnabled || this.bsConfig && this.bsConfig.datesEnabled,
        initCurrentTime: this.bsConfig?.initCurrentTime
      });
      this._datepickerRef = this._datepicker.provide({
        provide: BsDatepickerConfig,
        useValue: this._config
      }).attach(BsDatepickerInlineContainerComponent).to(this._elementRef).show();
      this.initSubscribes();
    }
    ngOnDestroy() {
      this._datepicker.dispose();
      this.unsubscribeSubscriptions();
    }
    static {
      this.ɵfac = function BsDatepickerInlineDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsDatepickerInlineDirective)(i0.ɵɵdirectiveInject(BsDatepickerInlineConfig), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i2$1.ComponentLoaderFactory));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: BsDatepickerInlineDirective,
        selectors: [["bs-datepicker-inline"]],
        inputs: {
          bsConfig: "bsConfig",
          isDisabled: "isDisabled",
          minDate: "minDate",
          maxDate: "maxDate",
          dateCustomClasses: "dateCustomClasses",
          dateTooltipTexts: "dateTooltipTexts",
          datesEnabled: "datesEnabled",
          datesDisabled: "datesDisabled",
          bsValue: "bsValue"
        },
        outputs: {
          bsValueChange: "bsValueChange"
        },
        exportAs: ["bsDatepickerInline"],
        standalone: true,
        features: [i0.ɵɵProvidersFeature([ComponentLoaderFactory]), i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return BsDatepickerInlineDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsDaterangepickerInlineConfig = /*#__PURE__*/(() => {
  class BsDaterangepickerInlineConfig extends BsDatepickerConfig {
    constructor() {
      super(...arguments);
      // DatepickerRenderOptions
      this.displayMonths = 2;
      /** turn on/off animation */
      this.isAnimated = false;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵBsDaterangepickerInlineConfig_BaseFactory;
        return function BsDaterangepickerInlineConfig_Factory(__ngFactoryType__) {
          return (ɵBsDaterangepickerInlineConfig_BaseFactory || (ɵBsDaterangepickerInlineConfig_BaseFactory = i0.ɵɵgetInheritedFactory(BsDaterangepickerInlineConfig)))(__ngFactoryType__ || BsDaterangepickerInlineConfig);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BsDaterangepickerInlineConfig,
        factory: BsDaterangepickerInlineConfig.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BsDaterangepickerInlineConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsDaterangepickerContainerComponent = /*#__PURE__*/(() => {
  class BsDaterangepickerContainerComponent extends BsDatepickerAbstractComponent {
    set value(value) {
      this._effects?.setRangeValue(value);
    }
    get isDatePickerDisabled() {
      return !!this._config.isDisabled;
    }
    get isDatepickerDisabled() {
      return this.isDatePickerDisabled ? '' : null;
    }
    get isDatepickerReadonly() {
      return this.isDatePickerDisabled ? '' : null;
    }
    constructor(_renderer, _config, _store, _element, _actions, _effects, _positionService) {
      super();
      this._config = _config;
      this._store = _store;
      this._element = _element;
      this._actions = _actions;
      this._positionService = _positionService;
      this.valueChange = new EventEmitter();
      this.animationState = 'void';
      this._rangeStack = [];
      this.chosenRange = [];
      this._subs = [];
      this.isRangePicker = true;
      this._effects = _effects;
      this.customRanges = this._config.ranges || [];
      this.customRangeBtnLbl = this._config.customRangeButtonLabel;
      _renderer.setStyle(_element.nativeElement, 'display', 'block');
      _renderer.setStyle(_element.nativeElement, 'position', 'absolute');
    }
    ngOnInit() {
      this._positionService.setOptions({
        modifiers: {
          flip: {
            enabled: this._config.adaptivePosition
          },
          preventOverflow: {
            enabled: this._config.adaptivePosition
          }
        },
        allowedPositions: this._config.allowedPositions
      });
      this._positionService.event$?.pipe(take(1)).subscribe(() => {
        this._positionService.disable();
        if (this._config.isAnimated) {
          this.animationState = this.isTopPosition ? 'animated-up' : 'animated-down';
          return;
        }
        this.animationState = 'unanimated';
      });
      this.containerClass = this._config.containerClass;
      this.isOtherMonthsActive = this._config.selectFromOtherMonth;
      this.withTimepicker = this._config.withTimepicker;
      this._effects?.init(this._store)
      // intial state options
      // todo: fix this, split configs
      .setOptions(this._config)
      // data binding view --> model
      .setBindings(this)
      // set event handlers
      .setEventHandlers(this).registerDatepickerSideEffects();
      let currentDate;
      // todo: move it somewhere else
      // on selected date change
      this._subs.push(this._store.select(state => state.selectedRange).subscribe(dateRange => {
        currentDate = dateRange;
        this.valueChange.emit(dateRange);
        this.chosenRange = dateRange || [];
      }));
      this._subs.push(this._store.select(state => state.selectedTime).subscribe(time => {
        if (!time || !time[0] || !time[1] || !(time[0] instanceof Date) || !(time[1] instanceof Date) || currentDate && time[0] === currentDate[0] && time[1] === currentDate[1]) {
          return;
        }
        this.valueChange.emit(time);
        this.chosenRange = time || [];
      }));
    }
    ngAfterViewInit() {
      this.selectedTimeSub.add(this.selectedTime?.subscribe(val => {
        if (Array.isArray(val) && val.length >= 2) {
          this.startTimepicker?.writeValue(val[0]);
          this.endTimepicker?.writeValue(val[1]);
        }
      }));
      this.startTimepicker?.registerOnChange(val => {
        this.timeSelectHandler(val, 0);
      });
      this.endTimepicker?.registerOnChange(val => {
        this.timeSelectHandler(val, 1);
      });
    }
    get isTopPosition() {
      return this._element.nativeElement.classList.contains('top');
    }
    positionServiceEnable() {
      this._positionService.enable();
    }
    timeSelectHandler(date, index) {
      this._store.dispatch(this._actions.selectTime(date, index));
    }
    daySelectHandler(day) {
      if (!day) {
        return;
      }
      const isDisabled = this.isOtherMonthsActive ? day.isDisabled : day.isOtherMonth || day.isDisabled;
      if (isDisabled) {
        return;
      }
      this.rangesProcessing(day);
    }
    monthSelectHandler(day) {
      if (!day || day.isDisabled) {
        return;
      }
      day.isSelected = true;
      if (this._config.minMode !== 'month') {
        if (day.isDisabled) {
          return;
        }
        this._store.dispatch(this._actions.navigateTo({
          unit: {
            month: getMonth(day.date),
            year: getFullYear(day.date)
          },
          viewMode: 'day'
        }));
        return;
      }
      this.rangesProcessing(day);
    }
    yearSelectHandler(day) {
      if (!day || day.isDisabled) {
        return;
      }
      day.isSelected = true;
      if (this._config.minMode !== 'year') {
        if (day.isDisabled) {
          return;
        }
        this._store.dispatch(this._actions.navigateTo({
          unit: {
            year: getFullYear(day.date)
          },
          viewMode: 'month'
        }));
        return;
      }
      this.rangesProcessing(day);
    }
    rangesProcessing(day) {
      // if only one date is already selected
      // and user clicks on previous date
      // start selection from new date
      // but if new date is after initial one
      // than finish selection
      if (this._rangeStack.length === 1) {
        this._rangeStack = day.date >= this._rangeStack[0] ? [this._rangeStack[0], day.date] : [day.date];
      }
      if (this._config.maxDateRange) {
        this.setMaxDateRangeOnCalendar(day.date);
      }
      if (this._rangeStack.length === 0) {
        this._rangeStack = [day.date];
        if (this._config.maxDateRange) {
          this.setMaxDateRangeOnCalendar(day.date);
        }
      }
      this._store.dispatch(this._actions.selectRange(this._rangeStack));
      if (this._rangeStack.length === 2) {
        this._rangeStack = [];
      }
    }
    ngOnDestroy() {
      for (const sub of this._subs) {
        sub.unsubscribe();
      }
      this.selectedTimeSub.unsubscribe();
      this._effects?.destroy();
    }
    setRangeOnCalendar(dates) {
      if (dates) {
        this._rangeStack = dates.value instanceof Date ? [dates.value] : dates.value;
      }
      this._store.dispatch(this._actions.selectRange(this._rangeStack));
    }
    setMaxDateRangeOnCalendar(currentSelection) {
      let maxDateRange = new Date(currentSelection);
      if (this._config.maxDate) {
        const maxDateValueInMilliseconds = this._config.maxDate.getTime();
        const maxDateRangeInMilliseconds = currentSelection.getTime() + (this._config.maxDateRange || 0) * dayInMilliseconds;
        maxDateRange = maxDateRangeInMilliseconds > maxDateValueInMilliseconds ? new Date(this._config.maxDate) : new Date(maxDateRangeInMilliseconds);
      } else {
        maxDateRange.setDate(currentSelection.getDate() + (this._config.maxDateRange || 0));
      }
      this._effects?.setMaxDate(maxDateRange);
    }
    static {
      this.ɵfac = function BsDaterangepickerContainerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsDaterangepickerContainerComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(BsDatepickerConfig), i0.ɵɵdirectiveInject(BsDatepickerStore), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(BsDatepickerActions), i0.ɵɵdirectiveInject(BsDatepickerEffects), i0.ɵɵdirectiveInject(i5.PositioningService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BsDaterangepickerContainerComponent,
        selectors: [["bs-daterangepicker-container"]],
        viewQuery: function BsDaterangepickerContainerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c3, 5);
            i0.ɵɵviewQuery(_c4, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.startTimepicker = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.endTimepicker = _t.first);
          }
        },
        hostAttrs: ["role", "dialog", "aria-label", "calendar", 1, "bottom"],
        hostVars: 2,
        hostBindings: function BsDaterangepickerContainerComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function BsDaterangepickerContainerComponent_click_HostBindingHandler($event) {
              return ctx._stopPropagation($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("disabled", ctx.isDatepickerDisabled)("readonly", ctx.isDatepickerReadonly);
          }
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([BsDatepickerStore, BsDatepickerEffects, BsDatepickerActions, PositioningService]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 3,
        consts: [["startTP", ""], ["endTP", ""], ["class", "bs-datepicker", 3, "ngClass", 4, "ngIf"], [1, "bs-datepicker", 3, "ngClass"], [1, "bs-datepicker-container"], ["role", "application", 1, "bs-calendar-container", 3, "ngSwitch"], [4, "ngSwitchCase"], ["class", "bs-media-container", 4, "ngSwitchCase"], ["class", "bs-datepicker-buttons", 4, "ngIf"], ["class", "bs-datepicker-custom-range", 4, "ngIf"], [1, "bs-media-container"], [3, "bs-datepicker-multiple", "calendar", "isDisabled", "options", "onNavigate", "onViewMode", "onHover", "onHoverWeek", "onSelect", 4, "ngFor", "ngForOf"], ["class", "bs-timepicker-in-datepicker-container", 4, "ngIf"], [3, "onNavigate", "onViewMode", "onHover", "onHoverWeek", "onSelect", "calendar", "isDisabled", "options"], [1, "bs-timepicker-in-datepicker-container"], [3, "disabled"], [3, "disabled", 4, "ngIf"], [3, "bs-datepicker-multiple", "calendar", "onNavigate", "onViewMode", "onHover", "onSelect", 4, "ngFor", "ngForOf"], [3, "onNavigate", "onViewMode", "onHover", "onSelect", "calendar"], [1, "bs-datepicker-buttons"], ["type", "button", 1, "btn", "btn-success"], ["type", "button", 1, "btn", "btn-default"], ["class", "btn-today-wrapper", 3, "today-left", "today-right", "today-center", 4, "ngIf"], ["class", "btn-clear-wrapper", 3, "clear-left", "clear-right", "clear-center", 4, "ngIf"], [1, "btn-today-wrapper"], [1, "btn", "btn-success", 3, "click"], [1, "btn-clear-wrapper"], [1, "bs-datepicker-custom-range"], [3, "onSelect", "selectedRange", "ranges", "customRangeLabel"]],
        template: function BsDaterangepickerContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, BsDaterangepickerContainerComponent_div_0_Template, 10, 11, "div", 2);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.viewMode));
          }
        },
        dependencies: [NgIf, NgClass, NgSwitch, NgSwitchCase, NgFor, BsDaysCalendarViewComponent, TimepickerModule, i6.TimepickerComponent, BsMonthCalendarViewComponent, BsYearsCalendarViewComponent, BsCustomDatesViewComponent, AsyncPipe],
        encapsulation: 2,
        data: {
          animation: [datepickerAnimation]
        }
      });
    }
  }
  return BsDaterangepickerContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsDaterangepickerInlineContainerComponent = /*#__PURE__*/(() => {
  class BsDaterangepickerInlineContainerComponent extends BsDaterangepickerContainerComponent {
    get disabledValue() {
      return this.isDatePickerDisabled ? '' : null;
    }
    get readonlyValue() {
      return this.isDatePickerDisabled ? '' : null;
    }
    constructor(_renderer, _config, _store, _element, _actions, _effects, _positioningService) {
      super(_renderer, _config, _store, _element, _actions, _effects, _positioningService);
      _renderer.setStyle(_element.nativeElement, 'display', 'inline-block');
      _renderer.setStyle(_element.nativeElement, 'position', 'static');
    }
    static {
      this.ɵfac = function BsDaterangepickerInlineContainerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsDaterangepickerInlineContainerComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(BsDatepickerConfig), i0.ɵɵdirectiveInject(BsDatepickerStore), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(BsDatepickerActions), i0.ɵɵdirectiveInject(BsDatepickerEffects), i0.ɵɵdirectiveInject(i5.PositioningService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BsDaterangepickerInlineContainerComponent,
        selectors: [["bs-daterangepicker-inline-container"]],
        hostVars: 2,
        hostBindings: function BsDaterangepickerInlineContainerComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function BsDaterangepickerInlineContainerComponent_click_HostBindingHandler($event) {
              return ctx._stopPropagation($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("disabled", ctx.disabledValue)("readonly", ctx.readonlyValue);
          }
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([BsDatepickerStore, BsDatepickerEffects, BsDatepickerActions, PositioningService]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 3,
        consts: [["startTP", ""], ["endTP", ""], ["class", "bs-datepicker", 3, "ngClass", 4, "ngIf"], [1, "bs-datepicker", 3, "ngClass"], [1, "bs-datepicker-container"], ["role", "application", 1, "bs-calendar-container", 3, "ngSwitch"], [4, "ngSwitchCase"], ["class", "bs-media-container", 4, "ngSwitchCase"], ["class", "bs-datepicker-buttons", 4, "ngIf"], ["class", "bs-datepicker-custom-range", 4, "ngIf"], [1, "bs-media-container"], [3, "bs-datepicker-multiple", "calendar", "isDisabled", "options", "onNavigate", "onViewMode", "onHover", "onHoverWeek", "onSelect", 4, "ngFor", "ngForOf"], ["class", "bs-timepicker-in-datepicker-container", 4, "ngIf"], [3, "onNavigate", "onViewMode", "onHover", "onHoverWeek", "onSelect", "calendar", "isDisabled", "options"], [1, "bs-timepicker-in-datepicker-container"], [3, "disabled"], [3, "disabled", 4, "ngIf"], [3, "bs-datepicker-multiple", "calendar", "onNavigate", "onViewMode", "onHover", "onSelect", 4, "ngFor", "ngForOf"], [3, "onNavigate", "onViewMode", "onHover", "onSelect", "calendar"], [1, "bs-datepicker-buttons"], ["type", "button", 1, "btn", "btn-success"], ["type", "button", 1, "btn", "btn-default"], ["class", "btn-today-wrapper", 3, "today-left", "today-right", "today-center", 4, "ngIf"], ["class", "btn-clear-wrapper", 3, "clear-left", "clear-right", "clear-center", 4, "ngIf"], [1, "btn-today-wrapper"], [1, "btn", "btn-success", 3, "click"], [1, "btn-clear-wrapper"], [1, "bs-datepicker-custom-range"], [3, "onSelect", "selectedRange", "ranges", "customRangeLabel"]],
        template: function BsDaterangepickerInlineContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, BsDaterangepickerInlineContainerComponent_div_0_Template, 10, 11, "div", 2);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.viewMode));
          }
        },
        dependencies: [NgIf, NgClass, NgSwitch, NgSwitchCase, NgFor, BsDaysCalendarViewComponent, TimepickerModule, i6.TimepickerComponent, BsMonthCalendarViewComponent, BsYearsCalendarViewComponent, BsCustomDatesViewComponent, AsyncPipe],
        encapsulation: 2,
        data: {
          animation: [datepickerAnimation]
        }
      });
    }
  }
  return BsDaterangepickerInlineContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsDaterangepickerInlineDirective = /*#__PURE__*/(() => {
  class BsDaterangepickerInlineDirective {
    /**
     * Initial value of datepicker
     */
    set bsValue(value) {
      if (this._bsValue === value) {
        return;
      }
      if (value && this.bsConfig?.initCurrentTime) {
        value = setDateRangesCurrentTimeOnDateSelect(value);
      }
      this._bsValue = value;
      this.bsValueChange.emit(value);
    }
    constructor(_config, _elementRef, _renderer, _viewContainerRef, cis) {
      this._config = _config;
      this._elementRef = _elementRef;
      /**
       * Indicates whether datepicker is enabled or not
       */
      this.isDisabled = false;
      /**
       * Emits when daterangepicker value has been changed
       */
      this.bsValueChange = new EventEmitter();
      this._subs = [];
      // todo: assign only subset of fields
      Object.assign(this, this._config);
      this._datepicker = cis.createLoader(_elementRef, _viewContainerRef, _renderer);
    }
    ngOnInit() {
      this.setConfig();
      this.initSubscribes();
    }
    ngOnChanges(changes) {
      if (changes["bsConfig"]) {
        if (changes["bsConfig"].currentValue.initCurrentTime && changes["bsConfig"].currentValue.initCurrentTime !== changes["bsConfig"].previousValue.initCurrentTime && this._bsValue) {
          this._bsValue = setDateRangesCurrentTimeOnDateSelect(this._bsValue);
          this.bsValueChange.emit(this._bsValue);
        }
      }
      if (!this._datepickerRef || !this._datepickerRef.instance) {
        return;
      }
      if (changes["minDate"]) {
        this._datepickerRef.instance.minDate = this.minDate;
      }
      if (changes["maxDate"]) {
        this._datepickerRef.instance.maxDate = this.maxDate;
      }
      if (changes["datesEnabled"]) {
        this._datepickerRef.instance.datesEnabled = this.datesEnabled;
        this._datepickerRef.instance.value = this._bsValue;
      }
      if (changes["datesDisabled"]) {
        this._datepickerRef.instance.datesDisabled = this.datesDisabled;
      }
      if (changes["daysDisabled"]) {
        this._datepickerRef.instance.daysDisabled = this.daysDisabled;
      }
      if (changes["isDisabled"]) {
        this._datepickerRef.instance.isDisabled = this.isDisabled;
      }
      if (changes["dateCustomClasses"]) {
        this._datepickerRef.instance.dateCustomClasses = this.dateCustomClasses;
      }
      this.setConfig();
    }
    /**
     * Set config for datepicker
     */
    setConfig() {
      if (this._datepicker) {
        this._datepicker.hide();
      }
      this._config = Object.assign({}, this._config, this.bsConfig, {
        value: checkBsValue(this._bsValue, this.maxDate || this.bsConfig && this.bsConfig.maxDate),
        isDisabled: this.isDisabled,
        minDate: this.minDate || this.bsConfig && this.bsConfig.minDate,
        maxDate: this.maxDate || this.bsConfig && this.bsConfig.maxDate,
        daysDisabled: this.daysDisabled || this.bsConfig && this.bsConfig.daysDisabled,
        dateCustomClasses: this.dateCustomClasses || this.bsConfig && this.bsConfig.dateCustomClasses,
        datesDisabled: this.datesDisabled || this.bsConfig && this.bsConfig.datesDisabled,
        datesEnabled: this.datesEnabled || this.bsConfig && this.bsConfig.datesEnabled,
        ranges: checkRangesWithMaxDate(this.bsConfig && this.bsConfig.ranges, this.maxDate || this.bsConfig && this.bsConfig.maxDate),
        maxDateRange: this.bsConfig && this.bsConfig.maxDateRange,
        initCurrentTime: this.bsConfig?.initCurrentTime
      });
      this._datepickerRef = this._datepicker.provide({
        provide: BsDatepickerConfig,
        useValue: this._config
      }).attach(BsDaterangepickerInlineContainerComponent).to(this._elementRef).show();
      this.initSubscribes();
    }
    initSubscribes() {
      this.unsubscribeSubscriptions();
      // if date changes from external source (model -> view)
      this._subs.push(this.bsValueChange.subscribe(value => {
        if (this._datepickerRef) {
          this._datepickerRef.instance.value = value;
        }
      }));
      // if date changes from picker (view -> model)
      if (this._datepickerRef) {
        this._subs.push(this._datepickerRef.instance.valueChange.pipe(filter(range => range && range[0] && !!range[1])).subscribe(value => {
          this.bsValue = value;
        }));
      }
    }
    unsubscribeSubscriptions() {
      if (this._subs?.length) {
        this._subs.map(sub => sub.unsubscribe());
        this._subs.length = 0;
      }
    }
    ngOnDestroy() {
      this._datepicker.dispose();
      this.unsubscribeSubscriptions();
    }
    static {
      this.ɵfac = function BsDaterangepickerInlineDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsDaterangepickerInlineDirective)(i0.ɵɵdirectiveInject(BsDaterangepickerInlineConfig), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i2$1.ComponentLoaderFactory));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: BsDaterangepickerInlineDirective,
        selectors: [["bs-daterangepicker-inline"]],
        inputs: {
          bsValue: "bsValue",
          bsConfig: "bsConfig",
          isDisabled: "isDisabled",
          minDate: "minDate",
          maxDate: "maxDate",
          dateCustomClasses: "dateCustomClasses",
          daysDisabled: "daysDisabled",
          datesDisabled: "datesDisabled",
          datesEnabled: "datesEnabled"
        },
        outputs: {
          bsValueChange: "bsValueChange"
        },
        exportAs: ["bsDaterangepickerInline"],
        standalone: true,
        features: [i0.ɵɵProvidersFeature([ComponentLoaderFactory]), i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return BsDaterangepickerInlineDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const BS_DATEPICKER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BsDatepickerInputDirective),
  multi: true
};
const BS_DATEPICKER_VALIDATOR = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => BsDatepickerInputDirective),
  multi: true
};
let BsDatepickerInputDirective = /*#__PURE__*/(() => {
  class BsDatepickerInputDirective {
    constructor(_picker, _localeService, _renderer, _elRef, changeDetection) {
      this._picker = _picker;
      this._localeService = _localeService;
      this._renderer = _renderer;
      this._elRef = _elRef;
      this.changeDetection = changeDetection;
      this._onChange = Function.prototype;
      this._onTouched = Function.prototype;
      this._validatorChange = Function.prototype;
      this._subs = new Subscription();
    }
    onChange(event) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.writeValue(event.target.value);
      this._onChange(this._value);
      if (this._picker._config.returnFocusToInput) {
        this._renderer.selectRootElement(this._elRef.nativeElement).focus();
      }
      this._onTouched();
    }
    onBlur() {
      this._onTouched();
    }
    hide() {
      this._picker.hide();
      this._renderer.selectRootElement(this._elRef.nativeElement).blur();
      if (this._picker._config.returnFocusToInput) {
        this._renderer.selectRootElement(this._elRef.nativeElement).focus();
      }
    }
    ngOnInit() {
      const setBsValue = value => {
        this._setInputValue(value);
        if (this._value !== value) {
          this._value = value;
          this._onChange(value);
          this._onTouched();
        }
        this.changeDetection.markForCheck();
      };
      // if value set via [bsValue] it will not get into value change
      if (this._picker._bsValue) {
        setBsValue(this._picker._bsValue);
      }
      // update input value on datepicker value update
      this._subs.add(this._picker.bsValueChange.subscribe(setBsValue));
      // update input value on locale change
      this._subs.add(this._localeService.localeChange.subscribe(() => {
        this._setInputValue(this._value);
      }));
      this._subs.add(this._picker.dateInputFormat$.pipe(distinctUntilChanged()).subscribe(() => {
        this._setInputValue(this._value);
      }));
    }
    ngOnDestroy() {
      this._subs.unsubscribe();
    }
    _setInputValue(value) {
      const initialDate = !value ? '' : formatDate(value, this._picker._config.dateInputFormat, this._localeService.currentLocale);
      this._renderer.setProperty(this._elRef.nativeElement, 'value', initialDate);
    }
    validate(c) {
      const _value = c.value;
      if (_value === null || _value === undefined || _value === '') {
        return null;
      }
      if (isDate(_value)) {
        const _isDateValid = isDateValid(_value);
        if (!_isDateValid) {
          return {
            bsDate: {
              invalid: _value
            }
          };
        }
        if (this._picker && this._picker.minDate && isBefore(_value, this._picker.minDate, 'date')) {
          this.writeValue(this._picker.minDate);
          return this._picker.ignoreMinMaxErrors ? null : {
            bsDate: {
              minDate: this._picker.minDate
            }
          };
        }
        if (this._picker && this._picker.maxDate && isAfter(_value, this._picker.maxDate, 'date')) {
          this.writeValue(this._picker.maxDate);
          return this._picker.ignoreMinMaxErrors ? null : {
            bsDate: {
              maxDate: this._picker.maxDate
            }
          };
        }
      }
      return null;
    }
    registerOnValidatorChange(fn) {
      this._validatorChange = fn;
    }
    writeValue(value) {
      if (!value) {
        this._value = void 0;
      } else {
        const _localeKey = this._localeService.currentLocale;
        const _locale = getLocale(_localeKey);
        if (!_locale) {
          throw new Error(`Locale "${_localeKey}" is not defined, please add it with "defineLocale(...)"`);
        }
        this._value = parseDate(value, this._picker._config.dateInputFormat, this._localeService.currentLocale);
        if (this._picker._config.useUtc) {
          const utcValue = utcAsLocal(this._value);
          this._value = utcValue === null ? void 0 : utcValue;
        }
      }
      this._picker.bsValue = this._value;
    }
    setDisabledState(isDisabled) {
      this._picker.isDisabled = isDisabled;
      if (isDisabled) {
        this._renderer.setAttribute(this._elRef.nativeElement, 'disabled', 'disabled');
        return;
      }
      this._renderer.removeAttribute(this._elRef.nativeElement, 'disabled');
    }
    registerOnChange(fn) {
      this._onChange = fn;
    }
    registerOnTouched(fn) {
      this._onTouched = fn;
    }
    static {
      this.ɵfac = function BsDatepickerInputDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsDatepickerInputDirective)(i0.ɵɵdirectiveInject(BsDatepickerDirective, 1), i0.ɵɵdirectiveInject(BsLocaleService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: BsDatepickerInputDirective,
        selectors: [["input", "bsDatepicker", ""]],
        hostBindings: function BsDatepickerInputDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("change", function BsDatepickerInputDirective_change_HostBindingHandler($event) {
              return ctx.onChange($event);
            })("blur", function BsDatepickerInputDirective_blur_HostBindingHandler() {
              return ctx.onBlur();
            })("keyup.esc", function BsDatepickerInputDirective_keyup_esc_HostBindingHandler() {
              return ctx.hide();
            })("keydown.enter", function BsDatepickerInputDirective_keydown_enter_HostBindingHandler() {
              return ctx.hide();
            });
          }
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([BS_DATEPICKER_VALUE_ACCESSOR, BS_DATEPICKER_VALIDATOR])]
      });
    }
  }
  return BsDatepickerInputDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsDaterangepickerConfig = /*#__PURE__*/(() => {
  class BsDaterangepickerConfig extends BsDatepickerConfig {
    constructor() {
      super(...arguments);
      // DatepickerRenderOptions
      this.displayMonths = 2;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵBsDaterangepickerConfig_BaseFactory;
        return function BsDaterangepickerConfig_Factory(__ngFactoryType__) {
          return (ɵBsDaterangepickerConfig_BaseFactory || (ɵBsDaterangepickerConfig_BaseFactory = i0.ɵɵgetInheritedFactory(BsDaterangepickerConfig)))(__ngFactoryType__ || BsDaterangepickerConfig);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BsDaterangepickerConfig,
        factory: BsDaterangepickerConfig.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BsDaterangepickerConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let previousDate;
let BsDaterangepickerDirective = /*#__PURE__*/(() => {
  class BsDaterangepickerDirective {
    /**
     * Returns whether or not the daterangepicker is currently being shown
     */
    get isOpen() {
      return this._datepicker.isShown;
    }
    set isOpen(value) {
      this.isOpen$.next(value);
    }
    /**
     * Initial value of daterangepicker
     */
    set bsValue(value) {
      if (this._bsValue === value) {
        return;
      }
      if (value && this.bsConfig?.initCurrentTime) {
        value = setDateRangesCurrentTimeOnDateSelect(value);
      }
      this.initPreviousValue();
      this._bsValue = value;
      this.bsValueChange.emit(value);
    }
    get isDatepickerReadonly() {
      return this.isDisabled ? '' : null;
    }
    get rangeInputFormat$() {
      return this._rangeInputFormat$;
    }
    constructor(_config, _elementRef, _renderer, _viewContainerRef, cis) {
      this._config = _config;
      this._elementRef = _elementRef;
      this._renderer = _renderer;
      /**
       * Placement of a daterangepicker. Accepts: "top", "bottom", "left", "right"
       */
      this.placement = 'bottom';
      /**
       * Specifies events that should trigger. Supports a space separated list of
       * event names.
       */
      this.triggers = 'click';
      /**
       * Close daterangepicker on outside click
       */
      this.outsideClick = true;
      /**
       * A selector specifying the element the daterangepicker should be appended to.
       */
      this.container = 'body';
      this.outsideEsc = true;
      this.isDestroy$ = new Subject();
      /**
       * Indicates whether daterangepicker's content is enabled or not
       */
      this.isDisabled = false;
      /**
       * Emits when daterangepicker value has been changed
       */
      this.bsValueChange = new EventEmitter();
      this._subs = [];
      this._rangeInputFormat$ = new Subject();
      this._datepicker = cis.createLoader(_elementRef, _viewContainerRef, _renderer);
      Object.assign(this, _config);
      this.onShown = this._datepicker.onShown;
      this.onHidden = this._datepicker.onHidden;
      this.isOpen$ = new BehaviorSubject(this.isOpen);
    }
    ngOnInit() {
      this.isDestroy$ = new Subject();
      this._datepicker.listen({
        outsideClick: this.outsideClick,
        outsideEsc: this.outsideEsc,
        triggers: this.triggers,
        show: () => this.show()
      });
      this.initPreviousValue();
      this.setConfig();
    }
    ngOnChanges(changes) {
      if (changes["bsConfig"]) {
        if (changes["bsConfig"].currentValue?.initCurrentTime && changes["bsConfig"].currentValue?.initCurrentTime !== changes["bsConfig"].previousValue?.initCurrentTime && this._bsValue) {
          this.initPreviousValue();
          this._bsValue = setDateRangesCurrentTimeOnDateSelect(this._bsValue);
          this.bsValueChange.emit(this._bsValue);
        }
        this.setConfig();
        this._rangeInputFormat$.next(changes["bsConfig"].currentValue && changes["bsConfig"].currentValue.rangeInputFormat);
      }
      if (!this._datepickerRef || !this._datepickerRef.instance) {
        return;
      }
      if (changes["minDate"]) {
        this._datepickerRef.instance.minDate = this.minDate;
      }
      if (changes["maxDate"]) {
        this._datepickerRef.instance.maxDate = this.maxDate;
      }
      if (changes["datesDisabled"]) {
        this._datepickerRef.instance.datesDisabled = this.datesDisabled;
      }
      if (changes["datesEnabled"]) {
        this._datepickerRef.instance.datesEnabled = this.datesEnabled;
      }
      if (changes["daysDisabled"]) {
        this._datepickerRef.instance.daysDisabled = this.daysDisabled;
      }
      if (changes["isDisabled"]) {
        this._datepickerRef.instance.isDisabled = this.isDisabled;
      }
      if (changes["dateCustomClasses"]) {
        this._datepickerRef.instance.dateCustomClasses = this.dateCustomClasses;
      }
    }
    ngAfterViewInit() {
      this.isOpen$.pipe(filter(isOpen => isOpen !== this.isOpen), takeUntil(this.isDestroy$)).subscribe(() => this.toggle());
    }
    /**
     * Opens an element’s datepicker. This is considered a “manual” triggering of
     * the datepicker.
     */
    show() {
      if (this._datepicker.isShown) {
        return;
      }
      this.setConfig();
      this._datepickerRef = this._datepicker.provide({
        provide: BsDatepickerConfig,
        useValue: this._config
      }).attach(BsDaterangepickerContainerComponent).to(this.container).position({
        attachment: this.placement
      }).show({
        placement: this.placement
      });
      this.initSubscribes();
    }
    initSubscribes() {
      // if date changes from external source (model -> view)
      this._subs.push(this.bsValueChange.subscribe(value => {
        if (this._datepickerRef) {
          this._datepickerRef.instance.value = value;
        }
      }));
      // if date changes from picker (view -> model)
      if (this._datepickerRef) {
        this._subs.push(this._datepickerRef.instance.valueChange.pipe(filter(range => range && range[0] && !!range[1])).subscribe(value => {
          this.initPreviousValue();
          this.bsValue = value;
          if (this.keepDatepickerModalOpened()) {
            return;
          }
          this.hide();
        }));
      }
    }
    initPreviousValue() {
      previousDate = this._bsValue;
    }
    keepDatepickerModalOpened() {
      if (!previousDate || !this.bsConfig?.keepDatepickerOpened || !this._config.withTimepicker) {
        return false;
      }
      return this.isDateSame();
    }
    isDateSame() {
      return this._bsValue?.[0]?.getDate() === previousDate?.[0]?.getDate() && this._bsValue?.[0]?.getMonth() === previousDate?.[0]?.getMonth() && this._bsValue?.[0]?.getFullYear() === previousDate?.[0]?.getFullYear() && this._bsValue?.[1]?.getDate() === previousDate?.[1]?.getDate() && this._bsValue?.[1]?.getMonth() === previousDate?.[1]?.getMonth() && this._bsValue?.[1]?.getFullYear() === previousDate?.[1]?.getFullYear();
    }
    /**
     * Set config for daterangepicker
     */
    setConfig() {
      this._config = Object.assign({}, this._config, this.bsConfig, {
        value: this.bsConfig?.keepDatesOutOfRules ? this._bsValue : checkBsValue(this._bsValue, this.maxDate || this.bsConfig && this.bsConfig.maxDate),
        isDisabled: this.isDisabled,
        minDate: this.minDate || this.bsConfig && this.bsConfig.minDate,
        maxDate: this.maxDate || this.bsConfig && this.bsConfig.maxDate,
        daysDisabled: this.daysDisabled || this.bsConfig && this.bsConfig.daysDisabled,
        dateCustomClasses: this.dateCustomClasses || this.bsConfig && this.bsConfig.dateCustomClasses,
        datesDisabled: this.datesDisabled || this.bsConfig && this.bsConfig.datesDisabled,
        datesEnabled: this.datesEnabled || this.bsConfig && this.bsConfig.datesEnabled,
        ranges: checkRangesWithMaxDate(this.bsConfig && this.bsConfig.ranges, this.maxDate || this.bsConfig && this.bsConfig.maxDate),
        maxDateRange: this.bsConfig && this.bsConfig.maxDateRange,
        initCurrentTime: this.bsConfig?.initCurrentTime,
        keepDatepickerOpened: this.bsConfig?.keepDatepickerOpened,
        keepDatesOutOfRules: this.bsConfig?.keepDatesOutOfRules
      });
    }
    /**
     * Closes an element’s datepicker. This is considered a “manual” triggering of
     * the datepicker.
     */
    hide() {
      if (this.isOpen) {
        this._datepicker.hide();
      }
      for (const sub of this._subs) {
        sub.unsubscribe();
      }
      if (this._config.returnFocusToInput) {
        this._renderer.selectRootElement(this._elementRef.nativeElement).focus();
      }
    }
    /**
     * Toggles an element’s datepicker. This is considered a “manual” triggering
     * of the datepicker.
     */
    toggle() {
      if (this.isOpen) {
        return this.hide();
      }
      this.show();
    }
    unsubscribeSubscriptions() {
      if (this._subs?.length) {
        this._subs.map(sub => sub.unsubscribe());
        this._subs.length = 0;
      }
    }
    ngOnDestroy() {
      this._datepicker.dispose();
      this.isOpen$.next(false);
      if (this.isDestroy$) {
        this.isDestroy$.next(null);
        this.isDestroy$.complete();
      }
      this.unsubscribeSubscriptions();
    }
    static {
      this.ɵfac = function BsDaterangepickerDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsDaterangepickerDirective)(i0.ɵɵdirectiveInject(BsDaterangepickerConfig), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i2$1.ComponentLoaderFactory));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: BsDaterangepickerDirective,
        selectors: [["", "bsDaterangepicker", ""]],
        hostVars: 1,
        hostBindings: function BsDaterangepickerDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("readonly", ctx.isDatepickerReadonly);
          }
        },
        inputs: {
          placement: "placement",
          triggers: "triggers",
          outsideClick: "outsideClick",
          container: "container",
          outsideEsc: "outsideEsc",
          isOpen: "isOpen",
          bsValue: "bsValue",
          bsConfig: "bsConfig",
          isDisabled: "isDisabled",
          minDate: "minDate",
          maxDate: "maxDate",
          dateCustomClasses: "dateCustomClasses",
          daysDisabled: "daysDisabled",
          datesDisabled: "datesDisabled",
          datesEnabled: "datesEnabled"
        },
        outputs: {
          onShown: "onShown",
          onHidden: "onHidden",
          bsValueChange: "bsValueChange"
        },
        exportAs: ["bsDaterangepicker"],
        standalone: true,
        features: [i0.ɵɵProvidersFeature([ComponentLoaderFactory]), i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return BsDaterangepickerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const BS_DATERANGEPICKER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BsDaterangepickerInputDirective),
  multi: true
};
const BS_DATERANGEPICKER_VALIDATOR = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => BsDaterangepickerInputDirective),
  multi: true
};
let BsDaterangepickerInputDirective = /*#__PURE__*/(() => {
  class BsDaterangepickerInputDirective {
    constructor(_picker, _localeService, _renderer, _elRef, changeDetection) {
      this._picker = _picker;
      this._localeService = _localeService;
      this._renderer = _renderer;
      this._elRef = _elRef;
      this.changeDetection = changeDetection;
      this._onChange = Function.prototype;
      this._onTouched = Function.prototype;
      this._validatorChange = Function.prototype;
      this._subs = new Subscription();
    }
    ngOnInit() {
      const setBsValue = value => {
        this._setInputValue(value);
        if (this._value !== value) {
          this._value = value;
          this._onChange(value);
          this._onTouched();
        }
        this.changeDetection.markForCheck();
      };
      // if value set via [bsValue] it will not get into value change
      if (this._picker._bsValue) {
        setBsValue(this._picker._bsValue);
      }
      // update input value on datepicker value update
      this._subs.add(this._picker.bsValueChange.subscribe(value => {
        this._setInputValue(value);
        if (this._value !== value) {
          this._value = value;
          this._onChange(value);
          this._onTouched();
        }
        this.changeDetection.markForCheck();
      }));
      // update input value on locale change
      this._subs.add(this._localeService.localeChange.subscribe(() => {
        this._setInputValue(this._value);
      }));
      this._subs.add(
      // update input value on format change
      this._picker.rangeInputFormat$.pipe(distinctUntilChanged()).subscribe(() => {
        this._setInputValue(this._value);
      }));
    }
    ngOnDestroy() {
      this._subs.unsubscribe();
    }
    onKeydownEvent(event) {
      if (event.keyCode === 13 || event.code === 'Enter') {
        this.hide();
      }
    }
    _setInputValue(date) {
      let range = '';
      if (date) {
        const start = !date[0] ? '' : formatDate(date[0], this._picker._config.rangeInputFormat, this._localeService.currentLocale);
        const end = !date[1] ? '' : formatDate(date[1], this._picker._config.rangeInputFormat, this._localeService.currentLocale);
        range = start && end ? start + this._picker._config.rangeSeparator + end : '';
      }
      this._renderer.setProperty(this._elRef.nativeElement, 'value', range);
    }
    onChange(event) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.writeValue(event.target.value);
      this._onChange(this._value);
      if (this._picker._config.returnFocusToInput) {
        this._renderer.selectRootElement(this._elRef.nativeElement).focus();
      }
      this._onTouched();
    }
    validate(c) {
      let _value = c.value;
      const errors = [];
      if (_value === null || _value === undefined || !isArray(_value)) {
        return null;
      }
      _value = _value.slice().sort((a, b) => a.getTime() - b.getTime());
      const _isFirstDateValid = isDateValid(_value[0]);
      const _isSecondDateValid = isDateValid(_value[1]);
      if (!_isFirstDateValid) {
        return {
          bsDate: {
            invalid: _value[0]
          }
        };
      }
      if (!_isSecondDateValid) {
        return {
          bsDate: {
            invalid: _value[1]
          }
        };
      }
      if (this._picker && this._picker.minDate && isBefore(_value[0], this._picker.minDate, 'date')) {
        _value[0] = this._picker.minDate;
        errors.push({
          bsDate: {
            minDate: this._picker.minDate
          }
        });
      }
      if (this._picker && this._picker.maxDate && isAfter(_value[1], this._picker.maxDate, 'date')) {
        _value[1] = this._picker.maxDate;
        errors.push({
          bsDate: {
            maxDate: this._picker.maxDate
          }
        });
      }
      if (errors.length > 0) {
        this.writeValue(_value);
        return errors;
      }
      return null;
    }
    registerOnValidatorChange(fn) {
      this._validatorChange = fn;
    }
    writeValue(value) {
      if (!value) {
        this._value = void 0;
      } else {
        const _localeKey = this._localeService.currentLocale;
        const _locale = getLocale(_localeKey);
        if (!_locale) {
          throw new Error(`Locale "${_localeKey}" is not defined, please add it with "defineLocale(...)"`);
        }
        let _input = [];
        if (typeof value === 'string') {
          const trimmedSeparator = this._picker._config.rangeSeparator.trim();
          if (value.replace(/[^-]/g, '').length > 1) {
            _input = value.split(this._picker._config.rangeSeparator);
          } else {
            _input = value.split(trimmedSeparator.length > 0 ? trimmedSeparator : this._picker._config.rangeSeparator).map(_val => _val.trim());
          }
        }
        if (Array.isArray(value)) {
          _input = value;
        }
        this._value = _input.map(_val => {
          if (this._picker._config.useUtc) {
            return utcAsLocal(parseDate(_val, this._picker._config.rangeInputFormat, this._localeService.currentLocale));
          }
          return parseDate(_val, this._picker._config.rangeInputFormat, this._localeService.currentLocale);
        }).map(date => isNaN(date.valueOf()) ? void 0 : date);
      }
      this._picker.bsValue = this._value;
    }
    setDisabledState(isDisabled) {
      this._picker.isDisabled = isDisabled;
      if (isDisabled) {
        this._renderer.setAttribute(this._elRef.nativeElement, 'disabled', 'disabled');
        return;
      }
      this._renderer.removeAttribute(this._elRef.nativeElement, 'disabled');
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registerOnChange(fn) {
      this._onChange = fn;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registerOnTouched(fn) {
      this._onTouched = fn;
    }
    onBlur() {
      this._onTouched();
    }
    hide() {
      this._picker.hide();
      this._renderer.selectRootElement(this._elRef.nativeElement).blur();
      if (this._picker._config.returnFocusToInput) {
        this._renderer.selectRootElement(this._elRef.nativeElement).focus();
      }
    }
    static {
      this.ɵfac = function BsDaterangepickerInputDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsDaterangepickerInputDirective)(i0.ɵɵdirectiveInject(BsDaterangepickerDirective, 1), i0.ɵɵdirectiveInject(BsLocaleService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: BsDaterangepickerInputDirective,
        selectors: [["input", "bsDaterangepicker", ""]],
        hostBindings: function BsDaterangepickerInputDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("change", function BsDaterangepickerInputDirective_change_HostBindingHandler($event) {
              return ctx.onChange($event);
            })("keyup.esc", function BsDaterangepickerInputDirective_keyup_esc_HostBindingHandler() {
              return ctx.hide();
            })("keydown", function BsDaterangepickerInputDirective_keydown_HostBindingHandler($event) {
              return ctx.onKeydownEvent($event);
            })("blur", function BsDaterangepickerInputDirective_blur_HostBindingHandler() {
              return ctx.onBlur();
            });
          }
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([BS_DATERANGEPICKER_VALUE_ACCESSOR, BS_DATERANGEPICKER_VALIDATOR])]
      });
    }
  }
  return BsDaterangepickerInputDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BsDatepickerModule = /*#__PURE__*/(() => {
  class BsDatepickerModule {
    // @deprecated method not required anymore, will be deleted in v19.0.0
    static forRoot() {
      return {
        ngModule: BsDatepickerModule,
        providers: []
      };
    }
    static {
      this.ɵfac = function BsDatepickerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BsDatepickerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: BsDatepickerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TooltipModule, TimepickerModule, BsDaysCalendarViewComponent, BsDatepickerContainerComponent, BsDatepickerInlineContainerComponent, BsDaterangepickerContainerComponent, BsDaterangepickerInlineContainerComponent]
      });
    }
  }
  return BsDatepickerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { BsDatepickerConfig, BsDatepickerContainerComponent, BsDatepickerDirective, BsDatepickerInlineConfig, BsDatepickerInlineContainerComponent, BsDatepickerInlineDirective, BsDatepickerInputDirective, BsDatepickerModule, BsDaterangepickerConfig, BsDaterangepickerContainerComponent, BsDaterangepickerDirective, BsDaterangepickerInlineConfig, BsDaterangepickerInlineContainerComponent, BsDaterangepickerInlineDirective, BsDaterangepickerInputDirective, BsLocaleService };
